/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line
  function registerInfiniteScrollLoadMoreButton() {
    const selectors = {
      loadMoreButton: ".js-load-more",
      totalPages: "[data-total-pages]",
      currentPage: "[data-current-page]",
      nextUrl: "[data-next-url]",
      loadMoreText: "[load-more-text]",
      loaderText: "[loader-text]",
      products:
        ".collection__products .grid-item.product-item.product-item-card:not(.product-grid-item-placeholder)",
      productGrid: "div[data-products-grid] .grid",
      currentProducts: ".current-products",
      totalProducts: ".total-products",
      nextCollection: "#NextCollection",
    };

    const hideClass = "hide";
    const loadMoreButton = document.querySelector(selectors.loadMoreButton);
    const nextCollection = document.querySelector(selectors.nextCollection);
    const currentProducts = document.querySelector(selectors.currentProducts);
    const totalProducts = document.querySelector(selectors.totalProducts);
    const totalPages = document.querySelector(selectors.totalPages);

    // Show "next-collection" if no Load More button or all products are already visible
    if (
      !loadMoreButton ||
      (totalProducts &&
        currentProducts &&
        currentProducts.textContent === totalProducts.textContent)
    ) {
      if (nextCollection) {
        // nextCollection.classList.remove("hidden"); // Disabled by Christian
      }
      return;
    }

    loadMoreButton.addEventListener("click", (e) => {
      const totalPagesValue = Number(totalPages.value);
      let currentPage = document.querySelector(selectors.currentPage);
      let currentPageValue = parseInt(currentPage.value);
      let nextUrl = document.querySelector(selectors.nextUrl);

      loadMoreButton.setAttribute("disabled", true);

      const loadMoreText = loadMoreButton.querySelector(selectors.loadMoreText);
      const loaderText = loadMoreButton.querySelector(selectors.loaderText);

      loadMoreText.classList.add(hideClass);
      loaderText.classList.remove(hideClass);

      fetch(nextUrl.value)
        .then((response) => response.text())
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");
          const products = doc.querySelectorAll(selectors.products);
          insertProducts(products);

          const newUrl = nextUrl.value;

          nextUrl.value = nextUrl.value.replace(
            `page=${currentPageValue + 1}`,
            `page=${currentPageValue + 2}`
          );
          currentPage.value = currentPageValue + 1;

          if (currentPage.value >= totalPagesValue) {
            loadMoreButton.classList.add(hideClass);

            if (currentProducts && totalProducts) {
              currentProducts.innerHTML = totalProducts.innerHTML;
            }

            // if (nextCollection) {
            //   nextCollection.classList.remove("hidden");
            // }
          }

          loadMoreButton.removeAttribute("disabled");
          loadMoreText.classList.remove(hideClass);
          loaderText.classList.add(hideClass);

          window.history.pushState(
            {
              param: Shopify.queryParams,
            },
            document.title,
            newUrl
          );
        })
        .catch((error) => {
          console.warn("Loading more products failed", error);
          loadMoreButton.classList.add(hideClass);
        });
    });
  }

  function insertProducts(products, before = false) {
    const selectors = {
      productGrid: "div[data-products-grid] .grid",
      currentProducts: ".current-products",
      productCard: ".grid-item.product-item.product-item-card:not(.product-grid-item-placeholder)",
    };

    const productGrid = document.querySelector(selectors.productGrid);

    products.forEach((product) => {
      if (before) {
        productGrid.prepend(product);
      } else {
        productGrid.appendChild(product);
      }
    });

    const currentProducts = document.querySelector(selectors.currentProducts);
    currentProducts.innerHTML = productGrid.querySelectorAll(selectors.productCard).length;
  }

  registerInfiniteScrollLoadMoreButton();

  // Add a data attribute with the current currency rate to the body
  document.body.dataset.currencyRate = Shopify.currency.rate;

  function validateCart(cart) {
    validateGifts(cart);
    validateLimitedProducts(cart);
  }

  function validateGifts(cart) {
    // If the cart only has 1 item, and it is an item with "product_title" equal to "Thank you for shopping", remove it
    if (cart.item_count === 1) {
      const item = cart.items[0];
      if (item.product_title === "Thank you for shopping") {
        console.log("Cart has only one item, which is a gift, removing it");

        fetch(`/cart/change.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ id: item.key, quantity: 0 }),
        })
          .then((response) => response.json())
          .then((data) => {
            console.log("Gift removed from cart:", data);
          })
          .catch((error) => {
            console.error("Error removing gift from cart:", error);
          });
      }
    }
  }

  function validateLimitedProducts(cart) {
    const limitedProductsSettings = window?.theme?.settings?.limitedProducts;

    const limitedHandles = limitedProductsSettings?.handles || [];
    const maxQuantity = limitedProductsSettings?.maxQuantity;
    const minPrice = Number(limitedProductsSettings?.minPrice[cart.currency] || 0);

    const popupMaxQuantity = document.querySelector(
      ".limited-products-popup-container.popup-max-quantity"
    );
    const popupMinPrice = document.querySelector(
      ".limited-products-popup-container.popup-min-price"
    );

    const isLimitedProduct = (item) => limitedHandles.includes(item.handle);
    const limitedProducts = cart.items.filter((item) => isLimitedProduct(item));

    if (!limitedProducts.length || !limitedHandles || !maxQuantity || !minPrice) return;

    const totalLimitedProducts = limitedProducts.reduce(
      (sum, item) => sum + item.quantity,
      0
    );
    const limitedProductsTotal = limitedProducts.reduce(
      (sum, item) => sum + item.final_price * item.quantity,
      0
    );
    const total = (cart.total_price - limitedProductsTotal) / 100;

    let shouldUpdate = false;
    let newQuantity = 0;
    let itemToUpdate = null;

    console.log("Limited products in cart:", limitedProducts);

    if (totalLimitedProducts > maxQuantity) {
      popupMinPrice?.classList.remove("open");
      popupMaxQuantity?.classList.add("open");
      // Find the limited product in the cart with the highest quantity
      itemToUpdate = limitedProducts.reduce((prev, current) =>
        prev.quantity > current.quantity ? prev : current
      );
      newQuantity = itemToUpdate.quantity - (totalLimitedProducts - maxQuantity);
      shouldUpdate = true;
    } else if (total < minPrice) {
      popupMaxQuantity?.classList.remove("open");
      popupMinPrice?.classList.add("open");
      newQuantity = 0;
      itemToUpdate = limitedProducts[0];
      shouldUpdate = true;
    }

    if (shouldUpdate && itemToUpdate) {
      fetch(`/cart/change.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: itemToUpdate?.key, quantity: newQuantity }),
      })
        .then((res) => res.json())
        .then((data) => console.log("Limited item updated in cart:", data))
        .catch((err) => console.error("Error updating limited item in cart:", err));
    }

    // Remove cart if only one limited product is present
    if ((cart.item_count === 1 || cart.items.length === 1) && isLimitedProduct(cart.items[0])) {
      const item = cart.items[0];
      fetch(`/cart/change.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: item.key, quantity: 0 }),
      })
        .then((res) => res.json())
        .then((data) => console.log("Limited item removed from cart:", data))
        .catch((err) => console.error("Error removing limited item from cart:", err));
      return;
    }
  }

  function handleFreeGifts() {
    const selectors = {
      rebuyCartAnchor: "[data-rebuy-cart-anchor='body']",
      rebuyCartItems: "ul[data-smartcart-items]",
      rebuyCartFreeGiftItems: [
        "ul[data-smartcart-items] .rebuy-cart__flyout-item.tag-freegift",
        "ul[data-smartcart-items] .rebuy-cart__flyout-item.tag-freegift1",
        "ul[data-smartcart-items] .rebuy-cart__flyout-item.tag-freegift2",
        "ul[data-smartcart-items] .rebuy-cart__flyout-item.tag-freegift3",
      ],
      rebuyCartFreeGiftsContainer: ".rebuy-cart__free-gifts",
    };

    let freeGifts = [];
    selectors.rebuyCartFreeGiftItems.forEach((selector) => {
      document.querySelectorAll(selector).forEach((el) => freeGifts.push(el));
    });

    if (!freeGifts.length) {
      const freeGiftsContainer = document.querySelector(selectors.rebuyCartFreeGiftsContainer);
      if (freeGiftsContainer) {
        freeGiftsContainer.remove();
      }
      return;
    }

    const body = document.querySelector(selectors.rebuyCartAnchor);

    if (!body) {
      console.warn("Rebuy cart body anchor not found.");
      return;
    }

    const freeGiftsContainer = document.createElement("ul");
    freeGiftsContainer.classList.add(selectors.rebuyCartFreeGiftsContainer.replace(".", ""));

    freeGifts.forEach((gift) => {
      const giftClone = gift.cloneNode(true);

      const handle = giftClone.querySelector(".rebuy-cart__flyout-item-product-title").href.split("/").pop();
      const freeGiftDescription = getFreeGiftDescription(handle);

      const infoContainer = giftClone.querySelector(".rebuy-cart__flyout-item-info");
      if (infoContainer && freeGiftDescription) {
        const descriptionElement = document.createElement("div");
        descriptionElement.classList.add("rebuy-cart__flyout-item-product-description");
        descriptionElement.textContent = freeGiftDescription;

        const titleElement = infoContainer.querySelector(".rebuy-cart__flyout-item-product-title");
        if (titleElement) {
          titleElement.insertAdjacentElement("afterend", descriptionElement);
        } else {
          infoContainer.appendChild(descriptionElement);
        }
      }

      freeGiftsContainer.appendChild(giftClone);
    });

    if (body.querySelector(selectors.rebuyCartFreeGiftsContainer)) {
      body.querySelector(selectors.rebuyCartFreeGiftsContainer).remove();
    }

    body.prepend(freeGiftsContainer);
  }

  function getFreeGiftDescription(productHandle) {
    const descriptionLines = window.theme.settings.freeGiftDescriptions?.split(",") || [];
    const matchedLine = descriptionLines.find((line) => {
      const lineParts = line.split(":");
      if (lineParts.length < 2) {
        return false; // Invalid line format
      }
      const lineHandle = lineParts[0].trim();
      return productHandle.includes(lineHandle);
    });

    if (matchedLine) {
      return matchedLine.split(":")[1].trim();
    }

    return null;
  }

  document.addEventListener("rebuy:smartcart.ready", (event) => {
    validateCart(event.detail.smartcart.cart);

    setTimeout(() => {
      handleFreeGifts();
    }, 700);
  });

  document.addEventListener("rebuy:cart.change", (event) => {
    validateCart(event.detail.cart.cart);

    setTimeout(() => {
      handleFreeGifts();
    }, 700);
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

// Update Rebuys Tiered Progress Bar minimum price for DE store
// Makes it possibe to have 2 values for stores using EUR here eu uses rebuys value and de uses schema value
function updateRebuyProgressBarForDE() {
  // Check if on de store
  const marketHandle = window.theme?.settings?.marketHandle;
  if (marketHandle !== 'de') {
    return;
  }

  // Find Free Shipping tier in Rebuy
  const freeShippingTier = Rebuy?.SmartCart?.progressBar?.tiers?.find(tier => tier.type === 'shipping');
  if (!freeShippingTier) {
    return;
  }

  // Get DE shipping limit from schema settings and convert to cents
  const freeShippingLimitDE = window.theme?.settings?.freeShippingLimit_de;
  const limitValue = typeof freeShippingLimitDE === 'string' 
    ? parseFloat(freeShippingLimitDE.replace(',', '.')) 
    : parseFloat(freeShippingLimitDE);
  
  if (isNaN(limitValue) || limitValue <= 0) {
    console.warn(`Invalid freeShippingLimit_de value: ${freeShippingLimitDE}`);
    return;
  }

  const limitInCents = Math.round(limitValue * 100);

  // Update the minimum and EUR currency-specific value
  freeShippingTier.minimum = limitInCents;
  if (freeShippingTier.presentment_currencies) {
    freeShippingTier.presentment_currencies.eur = limitInCents;
  }
}

/**
 * ============================================================
 * B2B VAT Compare-At Price Fix for Rebuy Smart Cart
 * ============================================================
 *
 * Problem: Rebuy shows the gross variant price (incl. VAT) as the
 * compare-at/strikethrough, but B2B customers with VAT removal should
 * see the net (VAT-free) price.
 *
 * Approach: Parse the compare-at DOM text and divide by the country's
 * VAT multiplier. Uses MutationObserver to re-apply after Rebuy re-renders.
 *
 * Note: /cart.js sets both price and original_price to the cart-transform
 * value, so we cannot use cart data to detect the original gross price.
 * DOM parsing is the only reliable approach.
 */
(function () {
  if (!window.theme?.b2b?.isEnabled) return;
  if (!window.theme?.b2b?.customer?.hasVatNumber) return;

  // --- VAT table (matches cart transform in run.ts) ---
  const VAT_BY_COUNTRY = {
    SE: 25, HR: 25, FI: 25.5, HU: 27,
    AT: 20, BG: 20, FR: 20,
    BE: 21, CZ: 21, LV: 21, LT: 21, NL: 21, RO: 21, SK: 21, ES: 21,
    DE: 7,
    CY: 24, EE: 24, GR: 24,
    IE: 23, PL: 23, PT: 23,
    IT: 22, SI: 22,
    LU: 17, MT: 18,
    DK: 25, NO: 25, GB: 20
  };

  const country = (window.Shopify?.country || '').toUpperCase();
  const vatRate = VAT_BY_COUNTRY[country];
  const vatLabel = window.theme.b2b.rebuyVatLabel || '';
  // "Visual only" countries: cart transform does NOT remove VAT, but we display excl. VAT visually
  const isVisualOnly = window.theme.b2b.isVisualOnlyVat || false;

  // Proceed if we have a VAT rate for this country
  if (!vatRate) {
    return;
  }

  const vatMultiplier = 1 + (vatRate / 100);

  let _observer = null;
  let _throttleTimer = null;
  const THROTTLE_MS = 100;

  // --- Money parsing helpers ---
  function parseMoneyText(text) {
    const raw = (text || '').trim();
    const match = raw.match(/([-+]?\d[\d\s.,]*)/);
    if (!match) return null;

    const numberChunk = match[1];
    const prefix = raw.slice(0, match.index);
    const suffix = raw.slice(match.index + numberChunk.length);

    let s = numberChunk.replace(/\s/g, '');
    const lastDot = s.lastIndexOf('.');
    const lastComma = s.lastIndexOf(',');
    const decPos = Math.max(lastDot, lastComma);

    let intPart = s;
    let decPart = '';

    if (decPos !== -1) {
      intPart = s.slice(0, decPos);
      decPart = s.slice(decPos + 1);
    }

    intPart = intPart.replace(/[.,]/g, '');
    const normalized = decPart ? intPart + '.' + decPart : intPart;
    const value = Number(normalized);

    if (!Number.isFinite(value)) return null;
    return { value, prefix, suffix };
  }

  function formatMoneyLike(originalText, value) {
    const parsed = parseMoneyText(originalText);
    if (!parsed) return originalText;
    const fixed = value.toFixed(2).replace('.', ',');
    // Ensure a space before suffix if it starts with a letter (e.g. "away from...")
    const suffix = parsed.suffix && /^[a-zA-Z]/.test(parsed.suffix) ? ' ' + parsed.suffix : parsed.suffix;
    return parsed.prefix + fixed + suffix;
  }

  // --- Core fix: convert compare-at prices from gross → net ---
  function fixCompareAtPrices() {
    const compareAtSpans = document.querySelectorAll(
      '.rebuy-cart__flyout-item .rebuy-money.compare-at span:not(.sr-only)'
    );
    if (!compareAtSpans.length) return;

    compareAtSpans.forEach((span) => {
      // Store original gross text on first encounter (survives re-applications)
      if (!span.dataset.vatGrossText) {
        span.dataset.vatGrossText = span.textContent;
      }

      const grossText = span.dataset.vatGrossText;
      const parsed = parseMoneyText(grossText);
      if (!parsed) return;

      const netPrice = parsed.value / vatMultiplier;
      const desired = formatMoneyLike(grossText, netPrice);

      if (span.textContent.trim() !== desired.trim()) {
        span.textContent = desired;
      }
    });
  }

  // --- Visual-only fix: convert line item actual prices from gross → net (DK/NO/GB) ---
  // For these countries, the cart transform does NOT remove VAT, so Rebuy shows gross prices.
  // We visually divide them to show "excl. VAT" — but checkout still charges incl. VAT.
  function fixLineItemPrices() {
    if (!isVisualOnly) return;

    const priceSpans = document.querySelectorAll(
      '.rebuy-cart__flyout-item .rebuy-cart__flyout-item-price .rebuy-money:not(.compare-at) span:not(.sr-only)'
    );
    if (!priceSpans.length) return;

    priceSpans.forEach((span) => {
      if (!span.dataset.vatGrossText) {
        span.dataset.vatGrossText = span.textContent;
      }

      const grossText = span.dataset.vatGrossText;
      const parsed = parseMoneyText(grossText);
      if (!parsed) return;

      const netPrice = parsed.value / vatMultiplier;
      const desired = formatMoneyLike(grossText, netPrice);

      if (span.textContent.trim() !== desired.trim()) {
        span.textContent = desired;
      }
    });
  }

  // --- Add VAT label (Incl./Excl.) to Rebuy cart item prices ---
  function addVatLabels() {
    if (!vatLabel) return;

    const priceContainers = document.querySelectorAll('.rebuy-cart__flyout-item .rebuy-cart__flyout-item-price');
    priceContainers.forEach((container) => {
      // Skip if label already exists in this container
      if (container.querySelector('.vat-label')) return;

      container.insertAdjacentHTML(
        'beforeend',
        '<span class="vat-label" style="font-size:0.7rem;opacity:0.7;">' + vatLabel + '</span>'
      );
    });

    // Add label to subtotal
    const subtotalAmount = document.querySelector('.rebuy-cart__flyout-subtotal-amount');
    if (subtotalAmount && !subtotalAmount.querySelector('.vat-label')) {
      subtotalAmount.insertAdjacentHTML(
        'beforeend',
        '<span class="vat-label" style="font-size:0.7rem;opacity:0.7;display:block;align-self:anchor-center;margin-left:4px;">' + vatLabel + '</span>'
      );
    }
  }

  // --- Visual-only fix: divide money amounts in the progress bar (DK/NO/GB) ---
  function fixProgressBarPrices() {
    if (!isVisualOnly) return;

    const prompts = document.querySelectorAll('.rebuy-cart__progress-bar-prompt');
    prompts.forEach((prompt) => {
      // Guard: if we already fixed this prompt and content hasn't changed (no Rebuy re-render), skip
      if (prompt.dataset.vatFixedText && prompt.textContent.trim() === prompt.dataset.vatFixedText.trim()) {
        return;
      }

      // Walk text nodes inside the prompt and replace money values
      const walker = document.createTreeWalker(prompt, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        const original = node.textContent;
        const parsed = parseMoneyText(original);
        if (!parsed) continue;

        const netValue = parsed.value / vatMultiplier;
        const replaced = formatMoneyLike(original, netValue);
        if (node.textContent !== replaced) {
          node.textContent = replaced;
        }
      }

      // Store what we set so we can detect fresh Rebuy re-renders
      prompt.dataset.vatFixedText = prompt.textContent;
    });
  }

  // --- Throttled MutationObserver ---
  function scheduleFixThrottled() {
    if (_throttleTimer) return;
    _throttleTimer = setTimeout(() => {
      _throttleTimer = null;
      if (_observer) _observer.disconnect();
      try {
        fixCompareAtPrices();
        fixLineItemPrices();
        fixProgressBarPrices();
        addVatLabels();
        reapplyShippingTotal(); // Re-apply shipping after Rebuy re-renders
      } finally {
        startObserving();
      }
    }, THROTTLE_MS);
  }

  function startObserving() {
    const flyout = document.querySelector('.rebuy-cart__flyout');
    if (!flyout || !_observer) return;
    _observer.observe(flyout, { childList: true, subtree: true, characterData: true });
  }

  function boot() {
    fixCompareAtPrices();
    fixLineItemPrices();
    fixProgressBarPrices();
    addVatLabels();
    reapplyShippingTotal();

    if (!_observer) {
      _observer = new MutationObserver(() => {
        scheduleFixThrottled();
      });
    }
    startObserving();

    // Rebuy may re-render after events — retry
    setTimeout(() => { fixCompareAtPrices(); fixLineItemPrices(); fixProgressBarPrices(); addVatLabels(); reapplyShippingTotal(); }, 200);
    setTimeout(() => { fixCompareAtPrices(); fixLineItemPrices(); fixProgressBarPrices(); addVatLabels(); reapplyShippingTotal(); }, 600);
  }

  // --- Rebuy event hooks ---
  document.addEventListener('rebuy:smartcart.ready', () => {
    boot();
  });

  document.addEventListener('rebuy:cart.change', () => {
    boot();
  });

  document.addEventListener('rebuy:smartcart.show', () => {
    fixCompareAtPrices();
    fixLineItemPrices();
    fixProgressBarPrices();
    addVatLabels();
    reapplyShippingTotal();
  });

  // Polling fallback for late Rebuy initialization
  let pollTries = 0;
  const pollInterval = setInterval(() => {
    pollTries++;
    if (document.querySelector('.rebuy-cart__flyout')) {
      boot();
      clearInterval(pollInterval);
    } else if (pollTries >= 30) {
      clearInterval(pollInterval);
    }
  }, 250);
})();

function initRebuyCart() {
  document.addEventListener("rebuy:smartcart.ready", (event) => {
    adjustRebuyContent();
    runRebuyCode(event.detail.smartcart.cart);
    replaceProgressStepIcons();
    handleCustomerRepurchase(event.detail.smartcart.cart);
    updateRebuyProgressBarForDE();
  });

  document.addEventListener("rebuy:cart.change", (event) => {
    const cart = event.detail.cart.cart;
    runRebuyCode(cart);
    replaceProgressStepIcons();
    handleCustomerRepurchase(event.detail.cart.cart);
    updateRebuyProgressBarForDE();
  });
}

function handleCustomerRepurchase(cart) {
  // Treat items as valid bundles if either bundleId or _bundleId exists
  const customBundleItems = cart.items.filter(item => {
    const isBundleProduct = item.product_type == "Customizable Bundle" || item.product?.tags?.includes("bundle-custom");
    const hasAnyBundleId = !!(item.properties?.bundleId || item.properties?._bundleId);
    return isBundleProduct && !hasAnyBundleId;
  });

  if (!customBundleItems.length) {
    return;
  }

  const cartItems = [...document.querySelectorAll('.rebuy-cart__flyout-item')];

  const removeItemFromCart = (itemKey) => {
    return fetch(`/cart/change.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: itemKey, quantity: 0 })
    }).then(response => response.json());
  };

  if (cartItems) {
    customBundleItems.forEach((item, index) => {
      const overallItemIndex = cart.items.findIndex(i => i.key === item.key);
      const domItem = cartItems[overallItemIndex];

      if (!domItem) {
        console.warn(`DOM item not found for item with key: ${item.key}`);
        return;
      }

      const noticeContainer = document.createElement('div');
      noticeContainer.classList.add('customer-repurchase-notice-container');

      const notice = document.createElement('span');
      const noticeText = window.theme.settings.customerRepurchaseNotice || '';
      notice.innerHTML = noticeText || '';
      notice.classList.add('customer-repurchase-notice');

      const iconContainer = document.createElement('span');
      iconContainer.innerHTML = `
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-info-icon lucide-info"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/></svg>
        `;

      noticeContainer.appendChild(iconContainer);
      noticeContainer.appendChild(notice);
      domItem.appendChild(noticeContainer);

      const reselectContainer = document.createElement('div');
      reselectContainer.classList.add('reselect-container');

      const reselectButton = document.createElement('button');
      const reselectText = window.theme.settings.customerRepurchaseReselectButton || '';
      reselectButton.innerHTML = reselectText || '';
      reselectButton.classList.add('reselect-button');
      reselectButton.type = 'button';
      reselectButton.addEventListener('click', () => {
        removeItemFromCart(item.key);
        window.location.href = `/products/${item.handle}#product-bundle-builder__section`;
      });

      const removeButton = document.createElement('button');
      const removeButtonText = window.theme.settings.customerRepurchaseRemoveButton;
      removeButton.textContent = removeButtonText;
      removeButton.classList.add('remove-button');
      removeButton.type = 'button';
      removeButton.addEventListener('click', () => {
        removeItemFromCart(item.key);
        window.location.reload();
      });

      reselectContainer.appendChild(reselectButton);
      reselectContainer.appendChild(removeButton);
      domItem.appendChild(reselectContainer);

      setTimeout(() => {
        openPopoverNotice()
      }, 1000);
    });

    const checkoutArea = document.querySelector('div[data-rebuy-component="checkout-area"]');
    const checkoutButton = checkoutArea?.querySelector('.rebuy-cart__checkout-button');

    if (checkoutButton) { 
      checkoutButton.style.display = 'none';

      const checkoutButtonDisabled = document.createElement('button');
      checkoutButtonDisabled.classList.add('reselect-checkout-button');
      checkoutButtonDisabled.disabled = true;
      const checkoutText = window.theme.settings.customerRepurchaseCheckoutButton || '';
      checkoutButtonDisabled.innerHTML = checkoutText || '';

      checkoutArea.appendChild(checkoutButtonDisabled);
    }
  }
}

function openPopoverNotice() {
  const body = document.querySelector('body');

  const backdrop = document.createElement('div');
  backdrop.classList.add('popover-notice-backdrop');
  backdrop.addEventListener('click', () => {
    backdrop.remove();
    popoverNotice.remove();
  });

  const popoverNotice = document.createElement('div');
  popoverNotice.classList.add('popover-notice-container');

  const popoverTop = document.createElement('div');
  popoverTop.classList.add('popover-notice-top');

  const popoverBottom = document.createElement('div');
  popoverBottom.classList.add('popover-notice-bottom');

  const iconContainer = document.createElement('span');
  iconContainer.innerHTML = `
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-info-icon lucide-info"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/></svg>
  `;

  const noticeText = document.createElement('span');
  noticeText.classList.add('popover-notice-text-title');
  const popoverTitle = window.theme.settings.popoverNoticeTitle || 'Information';
  noticeText.textContent = popoverTitle;

  const popoverX = document.createElement('span');
  popoverX.innerHTML = '&#10005;';
  popoverX.classList.add('popover-notice-x');
  popoverX.addEventListener('click', () => {
    backdrop.remove();
    popoverNotice.remove();
  });

  const popoverText = document.createElement('span');
  const popoverTextContent = window.theme.settings.popover_notice_text || 'There are one or more items in your cart that needs attention.';
  popoverText.innerHTML = popoverTextContent;
  popoverText.classList.add('popover-notice-text');

  const popoverButton = document.createElement('button');
  const popoverButtonText = window.theme.settings.popoverNoticeButton || 'Back to store';
  popoverButton.innerHTML = popoverButtonText;
  popoverButton.classList.add('popover-notice-button');
  popoverButton.addEventListener('click', () => {
    backdrop.remove();
    popoverNotice.remove();
  });

  popoverTop.appendChild(iconContainer);
  popoverTop.appendChild(noticeText);
  popoverTop.appendChild(popoverX);

  popoverBottom.appendChild(popoverText);
  popoverBottom.appendChild(popoverButton);

  popoverNotice.appendChild(popoverTop);
  popoverNotice.appendChild(popoverBottom);

  body.appendChild(backdrop);
  body.appendChild(popoverNotice);

}

function replaceProgressStepIcons() {
  const shippingIcon = "https://essentialfoods-shop.myshopify.com/cdn/shop/files/shipping.png";
  const giftCardIcon =
    "https://essentialfoods-shop.myshopify.com/cdn/shop/files/giftcard-progressbar.png";

  const progressIcons = document.querySelectorAll(".rebuy-cart__progress-step-icon");

  progressIcons.forEach((icon) => {
    const stepLabel = icon.parentElement.querySelector(".rebuy-cart__progress-step-label");
    const progressStep = icon.parentElement;

    let customIcon = "";
    const shippingLabels = ["SHIPPING", "FRAKT", "FRAGT", "VERSAND"];
    const giftCardLabels = ["GIFT", "GAVE", "GÅVA", "GESCHENK"];
    if (stepLabel && shippingLabels.some((_) => stepLabel.textContent.includes(_))) {
      customIcon = shippingIcon;
    } else if (stepLabel && giftCardLabels.some((_) => giftCardLabels.includes(_))) {
      customIcon = giftCardIcon;
    }

    icon.style.width = "30px";
    icon.style.height = "30px";
    icon.style.backgroundImage = `url(${customIcon})`;
    icon.style.backgroundSize = "contain";
    icon.style.backgroundRepeat = "no-repeat";
    icon.style.backgroundPosition = "center";

    const svgRebuy = icon.querySelector("svg");
    if (svgRebuy) {
      svgRebuy.style.display = "none";
    }

    if (progressStep.classList.contains("complete")) {
      icon.classList.add("custom-complete");
    } else {
      icon.classList.remove("custom-complete");
    }

    icon.innerHTML = "";
  });
}

const cartFooterTranslations = {
  en: {
    shipping: "Shipping",
    subtotal: "Subtotal",
    items: "items",
    item: "item",
    free: "Free",
  },
  da: {
    shipping: "Fragt",
    subtotal: "Subtotal",
    items: "produkter",
    item: "produkt",
    free: "Gratis",
  },
  sv: {
    shipping: "Frakt",
    subtotal: "Delsumma",
    items: "produkter",
    item: "produkt",
    free: "Gratis",
  },
  no: {
    shipping: "Frakt",
    subtotal: "Delsum",
    items: "produkter",
    item: "produkt",
    free: "Gratis",
  },
  de: {
    shipping: "Versand",
    subtotal: "Zwischensumme",
    items: "Artikel",
    item: "Artikel",
    free: "Kostenlos",
  },
};

// Stores the last shipping calculation so the VAT fix's MutationObserver
// can re-apply shipping after Rebuy re-renders and resets the total.
let _lastShippingTotal = null;

function reapplyShippingTotal() {
  if (!_lastShippingTotal) return;
  const { subtotalPrice, deliveryPrice } = _lastShippingTotal;
  const rebuyFooter = document.querySelector('div[data-rebuy-cart-anchor="footer"]');
  if (!rebuyFooter) return;

  const totalLine = rebuyFooter.querySelector(".rebuy-cart__flyout-subtotal-amount");
  if (!totalLine) return;

  const totalAmount = subtotalPrice + deliveryPrice;
  const formatted = formatMoney(totalAmount, window.theme.moneyFormat);

  // Check the first text node only (ignore vat-label spans)
  const firstTextNode = Array.from(totalLine.childNodes).find(n => n.nodeType === Node.TEXT_NODE);
  const currentText = firstTextNode ? firstTextNode.textContent.trim() : totalLine.textContent.trim();

  if (currentText !== formatted.trim()) {
    const existingVatLabel = totalLine.querySelector('.vat-label');
    totalLine.textContent = formatted;
    if (existingVatLabel) totalLine.appendChild(existingVatLabel);
  }
}

function runRebuyCode(cart) {
  const isB2b = window.theme.b2b?.isEnabled;
  const locale = Shopify?.locale;
  const translation = cartFooterTranslations[locale] ?? cartFooterTranslations.en;
  const rebuyFooter = document.querySelector('div[data-rebuy-cart-anchor="footer"]');

  if (!rebuyFooter) {
    return;
  }

  if (cart.item_count === 0) {
    rebuyFooter.style.display = "none";
    return;
  } else {
    rebuyFooter.style.display = "flex";
  }

  const subtotalPrice = cart.items_subtotal_price;
  const marketHandle = window.theme?.settings.marketHandle;
  const deliveryLimitSetting = window.theme?.settings[`freeShippingLimit_${marketHandle}`];
  const deliveryPriceSetting = window.theme?.settings[`shippingPrice_${marketHandle}`];

  // Visual-only VAT: divide displayed subtotal for DK/NO/GB (cart still charges incl. VAT)
  const _VISUAL_VAT_RATES = { DK: 25, NO: 25, GB: 20 };
  const _visualCountry = (window.Shopify?.country || '').toUpperCase();
  const _visualVatRate = window.theme?.b2b?.isVisualOnlyVat ? _VISUAL_VAT_RATES[_visualCountry] : null;
  const _displayMultiplier = _visualVatRate ? 1 + (_visualVatRate / 100) : 1;
  const displaySubtotalPrice = Math.round(subtotalPrice / _displayMultiplier);

  let deliveryPrice = deliveryPriceSetting
    ? Number(deliveryPriceSetting.replace(",", ".") * 100)
    : null;
  const deliveryLimit = deliveryLimitSetting ? Number(deliveryLimitSetting * 100) : null;

  if (!deliveryPrice || !deliveryLimit) {
    return;
  }

  if (subtotalPrice > deliveryLimit) {
    deliveryPrice = 0;
  }

  let footerDetails = rebuyFooter.querySelector(".footer-details");
  let estimatedDelivery;

  if (!footerDetails) {
    footerDetails = document.createElement("div");
    footerDetails.classList.add("footer-details");
    rebuyFooter.appendChild(footerDetails);
  } else {
    estimatedDelivery = footerDetails.querySelector(".estimated-delivery");
    footerDetails.innerHTML = "";
  }

  // Create subtotal line
  const subtotalLine = document.createElement("div");
  subtotalLine.classList.add("footer-details__line");

  const subtotalLeft = document.createElement("div");
  subtotalLeft.textContent = `${translation.subtotal} (${cart.item_count} ${cart.item_count > 1 ? translation.items : translation.item
    })`;

  const subtotalRight = document.createElement("div");
  subtotalRight.textContent = formatMoney(displaySubtotalPrice, window.theme.moneyFormat);
  subtotalLine.appendChild(subtotalLeft);
  subtotalLine.appendChild(subtotalRight);
  footerDetails.appendChild(subtotalLine);

  // Create delivery line
  const deliveryLine = document.createElement("div");
  deliveryLine.classList.add("footer-details__line");

  const deliveryLeft = document.createElement("div");
  deliveryLeft.textContent = translation.shipping;

  const deliveryRight = document.createElement("div");

  if (deliveryPrice === 0) {
    deliveryRight.textContent = translation.free;
  } else {
    deliveryRight.textContent = formatMoney(deliveryPrice, window.theme.moneyFormat);
  }

  deliveryLine.appendChild(deliveryLeft);
  deliveryLine.appendChild(deliveryRight);
  footerDetails.appendChild(deliveryLine);

  // Store shipping data for the VAT fix's MutationObserver to re-apply
  _lastShippingTotal = { subtotalPrice: displaySubtotalPrice, deliveryPrice };

  // Set the total (subtotal + shipping) on Rebuy's total element
  const totalLine = rebuyFooter.querySelector(".rebuy-cart__flyout-subtotal-amount");
  if (totalLine) {
    totalLine.textContent = formatMoney(displaySubtotalPrice + deliveryPrice, window.theme.moneyFormat);
  }

  if (estimatedDelivery && footerDetails) {
    if (!footerDetails.contains(estimatedDelivery)) {
      footerDetails.appendChild(estimatedDelivery);
    }
  }
}

function formatMoney(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || window.theme.moneyFormat;

  function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split('.');
    const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
    const centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case 'amount_with_apostrophe_separator':
      value = formatWithDelimiters(cents, 2, "'", '.');
      break;
    default:
      value = formatWithDelimiters(cents, 2);
  }

  return formatString.replace(placeholderRegex, value);
}

function adjustRebuyContent() {
  setTimeout(() => {
    const paymentIcons = document.querySelector(".cart__drawer__payment__icons");
    const checkoutArea = document.querySelector('div[data-rebuy-component="checkout-area"]');
    const estimatedDelivery = document.querySelector(".estimated-delivery");
    const footerContainer = document.querySelector('div[data-rebuy-cart-anchor="footer"]');
    const footerDetails = footerContainer?.querySelector(".footer-details");

    if (paymentIcons && checkoutArea && !footerContainer.contains(paymentIcons)) {
      const clonedPaymentIcons = paymentIcons.cloneNode(true);
      checkoutArea.appendChild(clonedPaymentIcons);
    }

    if (estimatedDelivery && footerContainer && footerDetails) {
      if (!footerDetails.contains(estimatedDelivery)) {
        if (!window.theme.b2b?.isEnabled) {
          footerDetails.appendChild(estimatedDelivery);
        }
      }
    }
  }, 500);
}

initRebuyCart();

async function addPreviousCollectionProducts() {
  const selectors = {
    products: ".grid-item.product-item.product-item-card",
    productGrid: "div[data-products-grid] .grid",
  };

  const previousProductDivs = document.querySelectorAll(".js-collection-previous-products");
  const reversedPreviousProductDivs = Array.from(previousProductDivs);
  const previousProducts = [];

  const promises = reversedPreviousProductDivs.map((div) => {
    const url = div.getAttribute("data-url");
    return fetch(url).then((response) => response.text());
  });

  const responses = await Promise.all(promises);

  responses.forEach((html, index) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    const products = doc.querySelectorAll(selectors.products);
    previousProducts.push(...products);
  });

  const productGrid = document.querySelector(selectors.productGrid);
  const placeholders = [...document.querySelectorAll(".product-grid-item-placeholder")];

  previousProducts.reverse().forEach((product, index) => {
    if (placeholders[index]) {
      placeholders[index].outerHTML = product.outerHTML;
    } else {
      productGrid.prepend(product);
    }
  });

  placeholders.slice(previousProducts.length).forEach((placeholder) => placeholder.remove());
}

(async function () {
  await addPreviousCollectionProducts();
})();

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

// Select the header element
const header = document.querySelector(".theme__header");

// Add a scroll event listener to monitor the header's state
window.addEventListener("scroll", () => {
  if (!header) return;

  const isStuck = header.classList.contains("js__header__stuck");
  const isTransparent = header.hasAttribute("data-header-transparent");

  // Add the 'has-border' class if header is stuck and remove it if transparent
  if (isStuck && !isTransparent) {
    header.classList.add("has-border"); // Ensure border is applied only when stuck
  } else {
    header.classList.remove("has-border"); // Remove border if it's transparent or not stuck
  }
});

function injectRechargeStyles(widget) {
  if (!widget.shadowRoot) {
    console.warn("Cannot inject styles: shadowRoot is not open or not ready.");
    return;
  }

  // Only inject once per widget
  const existing = widget.shadowRoot.querySelector("#myCustomStyles");
  if (!existing) {
    const styleEl = document.createElement("style");
    styleEl.id = "myCustomStyles";
    styleEl.textContent = `
      .rc-purchase-option {
        background-color: transparent !important;
        border: none !important;
      }

      .rc-price.strike-through.text-muted {
        color: rgba(32, 43, 33, 0.6) !important;
        font-weight: 400 !important;
      }

      .rc-price {
        color: var(--web-green-dark) !important;
        font-weight: 500 !important;
      }

      .rc-selection__root {
        border: 1px solid var(--soapstone) !important;
        padding: 15px 20px !important;
        margin-bottom: 15px !important;
      }

      .rc-purchase-option:hover {
        background-color: transparent !important;
      }

      .rc-purchase-option.rc-selection__onetime {
        border-bottom: 1px solid #ECE4D5 !important;
        padding-bottom: 15px !important;
      }

      .rc-purchase-option__sub-container {
        padding: 0 !important;
        margin: 0 !important;
        gap: 15px !important;
        padding-top: 15px !important;
      }

      .rc-purchase-option.rc-purchase-option__subscription .rc-purchase-option__label {
        margin-bottom: 15px !important;
      }

      .rc-purchase-option__prices {
        margin-left: 0 !important;
      }

      .rc-purchase-option__selector {
        font-size: var(--font-3) !important;
        font-weight: 500 !important;
        text-transform: uppercase !important;
        gap: 10px !important;
        color: var(--web-green-dark) !important;
      }

      .rc-purchase-option__checked-indicator {
        margin-right: 0 !important;
      }

      rc-learn-more {
        margin-left: 0 !important;
      }

      .rc-purchase-option__prices {
        flex-direction: row !important;
        gap: 5px !important;
      }

      .rc-purchase-option__selector {
        padding: 0 !important;        
      }

      .rc-purchase-option__label {
        padding: 0 !important;  
      }

      @media (max-width: 749px) {
        .rc-selection__root {
          padding-top: 15px !important;
          padding-bottom: 20px !important; 
          padding-left: 15px !important;
          padding-right: 15px !important;
        }
      }
    `;
    widget.shadowRoot.appendChild(styleEl);
  }

  // Handle nested Shadow DOM for rc-learn-more
  const learnMore = widget.shadowRoot.querySelector("rc-learn-more");
  if (learnMore && learnMore.shadowRoot) {
    const nestedStyleEl =
      learnMore.shadowRoot.querySelector("#nestedCustomStyles") || document.createElement("style");
    nestedStyleEl.id = "nestedCustomStyles";
    nestedStyleEl.textContent = `
      .rc-learn-more__trigger {
        background-color: transparent !important;
        color: var(--web-green) !important;
        width: 17px !important;
        height: 17px !important;
      }

      .rc-learn-more__trigger svg {
        fill: var(--web-green) !important; 
        width: 17px !important;
        height: 17px !important;
      }
    `;
    if (!learnMore.shadowRoot.querySelector("#nestedCustomStyles")) {
      learnMore.shadowRoot.appendChild(nestedStyleEl);
    }
  }

  // Handle nested Shadow DOM for rc-radio-icon
  const radioIcons = widget.shadowRoot.querySelectorAll("rc-radio-icon");
  radioIcons.forEach((icon) => {
    if (icon.shadowRoot) {
      const radioIconStyleEl =
        icon.shadowRoot.querySelector("#radioIconCustomStyles") || document.createElement("style");
      radioIconStyleEl.id = "radioIconCustomStyles";
      radioIconStyleEl.textContent = `
        svg.rc-unchecked-icon {
          stroke: var(--soapstone) !important; 
          width: 20px !important;
          height: 20px !important;
        }

        svg.rc-unchecked-icon rect {
          stroke: var(--soapstone) !important;
        }

        svg.rc-checked-icon {
          width: 20px !important;
          height: 20px !important;
        }

        svg.rc-checked-icon rect {
          stroke: var(--sage) !important;
        }

        svg.rc-checked-icon circle {
          fill: var(--web-green) !important; 
        }
      `;
      if (!icon.shadowRoot.querySelector("#radioIconCustomStyles")) {
        icon.shadowRoot.appendChild(radioIconStyleEl);
      }
    }
  });

  // Handle nested Shadow DOM for rc-benefits
  const benefits = widget.shadowRoot.querySelector("rc-benefits");
  if (benefits && benefits.shadowRoot) {
    const benefitsStyleEl =
      benefits.shadowRoot.querySelector("#benefitsCustomStyles") || document.createElement("style");
    benefitsStyleEl.id = "benefitsCustomStyles";
    benefitsStyleEl.textContent = `
      ul {
      list-style: none; 
      padding: 0;
      margin: 0;
      display: flex;
      flex-direction: column;
      gap: 4px;
    }

    ul li {
      position: relative;
      padding-left: 16px; 
      font-size: var(--font-3);
      color: #000000;
      line-height: normal !important;
    }

    ul li::before {
      content: '';
      position: absolute;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
      width: 7.5px; 
      height: 8px; 
      mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='9' height='10' viewBox='0 0 9 10' fill='none'%3E%3Cpath d='M1 5L4.5 8.5L8.5 0.5' stroke='%23D9AB57' stroke-linecap='round'/%3E%3C/svg%3E");
      mask-size: contain; 
      mask-position: center; 
      mask-repeat: no-repeat; 
      background-color: #D9AB57;
    }

    `;

    if (!benefits.shadowRoot.querySelector("#benefitsCustomStyles")) {
      benefits.shadowRoot.appendChild(benefitsStyleEl);
    }
  }

  // Handle nested Shadow DOM for rc-selling-plans
  const sellingPlans = widget.shadowRoot.querySelector("rc-selling-plans");
  if (sellingPlans && sellingPlans.shadowRoot) {
    const sellingPlansStyleEl =
      sellingPlans.shadowRoot.querySelector("#sellingPlansCustomStyles") ||
      document.createElement("style");

    if (sellingPlansStyleEl) {
      sellingPlansStyleEl.id = "sellingPlansCustomStyles";
      sellingPlansStyleEl.textContent = `
        .rc-plans-dropdown__select {
          padding: 12px 15px !important;
          border: 1px solid var(--sage) !important;
          color: var(--web-green-dark) !important;
          font-size: var(--font-3) !important;
          font-family: var(--FONT-STACK-BODY) !important;
          cursor: pointer !important;
          border-radius: 0 !important;
        }

        select:focus-visible {
          box-shadow: none !important;
        }

        .rc-plans-dropdown__icon {
          color: rgba(32, 43, 33, 0.6) !important;
          width: 18px !important;
          height: 18px !important;
        }

          @media (max-width: 749px) {
            .rc-plans-dropdown__select {
              padding: 10px 15px !important;
          }
        }
      `;

      if (!sellingPlans.shadowRoot.querySelector("#sellingPlansCustomStyles")) {
        sellingPlans.shadowRoot.appendChild(sellingPlansStyleEl);
      }
    }
  }

  // Selected subscription option
  const selectedOption = widget.shadowRoot.querySelector(".rc-purchase-option[rc-selected]");

  if (!selectedOption) {
    return;
  }

  // Price within the selected option
  const priceElement = selectedOption.querySelector(".rc-price:not(.strike-through)");
  if (!priceElement) {
    return;
  }

  // Extract the actual price, ignoring the "visually-hidden" span
  const price = Array.from(priceElement.childNodes)
    .filter((node) => node.nodeType === Node.TEXT_NODE)
    .map((node) => node.textContent.trim())
    .join("");

  const addToCartButtonPrice = document.querySelector("button[data-add-to-cart] .btn__text__price");
  if (addToCartButtonPrice) {
    addToCartButtonPrice.textContent = price;
  } else {
    console.warn("Add to Cart button price wrapper not found.");
  }

  const addToCartButton = document.querySelector("button[data-add-to-cart]");
  const isSubscription = selectedOption.classList.contains("rc-purchase-option__subscription");
  const buttonText = addToCartButton.querySelector(".btn__text");
  if (buttonText) {
    if (isSubscription) {
      buttonText.textContent = window.theme.strings.subscribe;
    } else {
      buttonText.textContent = window.theme.strings.addToCart;
    }
  }
}

function observeRechargeWidget() {
  const observer = new MutationObserver(() => {
    // Grab the widget if it exists
    const widget = document.querySelector("recharge-subscription-widget");
    if (!widget) return;

    widget.style.display = "none";

    if (widget.shadowRoot && widget.shadowRoot.querySelector(".rc-purchase-option")) {
      injectRechargeStyles(widget);

      widget.style.display = "";

      // // Observe changes within rc-radio-icon components
      // const radioIcons = widget.shadowRoot.querySelectorAll('rc-radio-icon');
      // radioIcons.forEach((icon) => {
      //   const iconObserver = new MutationObserver(() => {
      //     injectRechargeStyles(widget);
      //   });
      //   iconObserver.observe(icon.shadowRoot, { childList: true, subtree: true });
      // });

      observer.disconnect();
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
}

observeRechargeWidget();

// Watch for benefits and make them always visible
function watchForBenefitsAlwaysVisible() {
  let intervalId = setInterval(() => {
    const widget = document.querySelector("recharge-subscription-widget");
    if (!widget?.shadowRoot) return;

    const shadow1 = widget.shadowRoot;
    const subscriptionOption = shadow1.querySelector(".rc-purchase-option__subscription");
    if (!subscriptionOption) return;

    // Check if already processed
    if (subscriptionOption.hasAttribute("data-benefits-always-visible")) {
      clearInterval(intervalId);
      return;
    }

    const subscriptionLabel = subscriptionOption.querySelector(".rc-purchase-option__label");
    if (!subscriptionLabel) return;

    // Create benefits container
    createBenefitsContainer(shadow1, subscriptionOption, subscriptionLabel);
    
    subscriptionOption.setAttribute("data-benefits-always-visible", "true");
    clearInterval(intervalId);
  }, 10);
  
  setTimeout(() => {
    clearInterval(intervalId);
  }, 2000);
  
  return intervalId;
}

/**
 * Add cloned benefits container to widget
 */
function createBenefitsContainer(shadow1, subscriptionOption, subscriptionLabel) {
  // Check if container already exists
  if (shadow1.querySelector("#persistent-benefits-container")) {
    return;
  }
  
  // Get template and clone it
  const template = document.getElementById("subscription-benefits-template");
  if (!template) return;
  
  const benefitsWrapper = template.querySelector("#persistent-benefits-container");
  if (!benefitsWrapper) return;
  
  // Clone the container
  const clonedContainer = benefitsWrapper.cloneNode(true);
  
  // Inject styles to match rc-benefits exactly (includes CSS to hide original)
  injectPersistentBenefitsStyles(shadow1);
  
  // Insert UNDER rc-purchase-option__label
  subscriptionLabel.insertAdjacentElement("afterend", clonedContainer);
}

/**
 * Injects styles for persistent benefits container to match rc-benefits exactly
 */
function injectPersistentBenefitsStyles(shadow1) {
  // Check if styles already injected
  if (shadow1.querySelector("#persistent-benefits-styles")) {
    return;
  }
  
  const styleEl = document.createElement("style");
  styleEl.id = "persistent-benefits-styles";
  styleEl.textContent = `
    #persistent-benefits-container {
      display: block;
    }
    
    #persistent-benefits-container .compact.rc-benefits__list {
      padding: 1px 0;
      --rc-widget-bullet-icon-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTEwLjkyMTUgMTQuNzExNUwxNS42MDc0IDEwLjA0NjVMMTQuODMzNCA5LjI3MjQ2TDEwLjkyMTUgMTMuMTYzNUw5LjE1MDcxIDExLjQxMzVMOC4zNzY2OSAxMi4xODc1TDEwLjkyMTUgMTQuNzExNVpNMTIuMDAxNSAxOS41ODMzQzEwLjk2MjEgMTkuNTgzMyA5Ljk4MTQ4IDE5LjM4NiA5LjA1OTcxIDE4Ljk5MTJDOC4xMzc5MiAxOC41OTY1IDcuMzMxMSAxOC4wNTM0IDYuNjM5MjUgMTcuMzYxOUM1Ljk0NzM5IDE2LjY3MDMgNS40MDQwMSAxNS44NjM5IDUuMDA5MSAxNC45NDI1QzQuNjE0MiAxNC4wMjEyIDQuNDE2NzUgMTMuMDQwOCA0LjQxNjc1IDEyLjAwMTRDNC40MTY3NSAxMC45NDgxIDQuNjE0MTEgOS45NjQwNiA1LjAwODgzIDkuMDQ5MjNDNS40MDM1NSA4LjEzNDM4IDUuOTQ2NjggNy4zMzEwNCA2LjYzODIxIDYuNjM5MTlDNy4zMjk3NSA1Ljk0NzMzIDguMTM2MiA1LjQwMzk0IDkuMDU3NTYgNS4wMDkwNEM5Ljk3ODkxIDQuNjE0MTQgMTAuOTU5MyA0LjQxNjY5IDExLjk5ODcgNC40MTY2OUMxMy4wNTE5IDQuNDE2NjkgMTQuMDM2IDQuNjE0MDUgMTQuOTUwOCA1LjAwODc3QzE1Ljg2NTcgNS40MDM0OSAxNi42NjkgNS45NDY2MiAxNy4zNjA5IDYuNjM4MTVDMTguMDUyNyA3LjMyOTY5IDE4LjU5NjEgOC4xMzI2NyAxOC45OTEgOS4wNDcwOEMxOS4zODU5IDkuOTYxNDkgMTkuNTgzNCAxMC45NDUzIDE5LjU4MzQgMTEuOTk4NkMxOS41ODM0IDEzLjAzOCAxOS4zODYgMTQuMDE4NiAxOC45OTEzIDE0Ljk0MDRDMTguNTk2NiAxNS44NjIxIDE4LjA1MzQgMTYuNjY5IDE3LjM2MTkgMTcuMzYwOEMxNi42NzA0IDE4LjA1MjcgMTUuODY3NCAxOC41OTYxIDE0Ljk1MyAxOC45OTFDMTQuMDM4NiAxOS4zODU5IDEzLjA1NDcgMTkuNTgzMyAxMi4wMDE1IDE5LjU4MzNaTTEyLjAwMDEgMTguNUMxMy44MDU2IDE4LjUgMTUuMzQwMyAxNy44NjgxIDE2LjYwNDIgMTYuNjA0MkMxNy44NjgxIDE1LjM0MDMgMTguNTAwMSAxMy44MDU2IDE4LjUwMDEgMTJDMTguNTAwMSAxMC4xOTQ0IDE3Ljg2ODEgOC42NTk3MiAxNi42MDQyIDcuMzk1ODNDMTUuMzQwMyA2LjEzMTk0IDEzLjgwNTYgNS41IDEyLjAwMDEgNS41QzEwLjE5NDUgNS41IDguNjU5NzggNi4xMzE5NCA3LjM5NTg5IDcuMzk1ODNDNi4xMzIgOC42NTk3MiA1LjUwMDA2IDEwLjE5NDQgNS41MDAwNiAxMkM1LjUwMDA2IDEzLjgwNTYgNi4xMzIgMTUuMzQwMyA3LjM5NTg5IDE2LjYwNDJDOC42NTk3OCAxNy44NjgxIDEwLjE5NDUgMTguNSAxMi4wMDAxIDE4LjVaIiBmaWxsPSJjdXJyZW50Q29sb3IiPjwvcGF0aD48L3N2Zz4K);
      --rc-widget-bullet-icon-image-color: var(--rc-widget-brand-color);
    }
    
    #persistent-benefits-container .compact.rc-benefits__list ul {
      list-style: none;
      padding: 0;
      margin: 0;
    }
    
    #persistent-benefits-container .compact.rc-benefits__list.compact li {
      margin-bottom: 0;
    }
    
    #persistent-benefits-container .compact.rc-benefits__list li {
      position: relative;
      padding-left: 1.75em;
    }
    
    #persistent-benefits-container .compact.rc-benefits__list li::before {
      content: '';
      height: 1em;
      width: 1em;
      position: absolute;
      top: 0.25em;
      left: 0;
      mask-image: var(--rc-widget-bullet-icon-image);
      mask-size: 140%;
      background-color: var(--rc-widget-bullet-icon-image-color, var(--rc-widget-brand-color));
      mask-position: calc(-0.25em + 1px) calc(-0.25em + 1px);
    }
    
    #persistent-benefits-container.compact p,
    #persistent-benefits-container .compact.rc-benefits__list p:last-child {
      margin: 0.5em 0;
    }
    
    /* Hide original rc-benefits element completely */
    rc-benefits {
      display: none !important;
    }
  `;
  
  shadow1.appendChild(styleEl);
}

watchForBenefitsAlwaysVisible();

(function () {
  async function loadAllProducts() {
    const templateSuffix = "json-bb";
    const collectionHandle = "all";

    const response = await fetch(`/collections/${collectionHandle}?view=${templateSuffix}`, {
      type: "GET",
    });

    const json = await response.json();
    window.ALL_VARIANTS = json.products;
  }

  loadAllProducts().then(() => {
    // console.log("VARIANTS LOADED: ", window.ALL_VARIANTS);
  });
})();

function removeUnrestrictedProducts() {
  const restrictedIds = window.theme.b2b?.customer.restrictedProductIds;

  document.querySelectorAll("[data-product-id]").forEach((element) => {
    if (element.classList.contains("bundle-builder-cart__item")) {
      return;
    }
    const productId = parseInt(element.dataset.productId, 10).toString();
    if (!restrictedIds.includes(productId)) {
      element.remove();
    }
  });
}

function lockRestrictedProducts() {
  const restrictedIds = window.theme.b2b?.customer.restrictedProductIds;

  if (window.location.pathname.includes("/products/")) {
    const productElement = document.querySelector("[data-product-id]");
    if (productElement) {
      const productId = parseInt(productElement.dataset.productId, 10).toString();
      if (!restrictedIds.includes(productId)) {
        window.location.href = "/";
        return;
      }
    }
  }
}

(function () {
  if (window.theme.b2b.isEnabled && window.theme.b2b.customer.restrictedProductIds.length > 0) {
    lockRestrictedProducts();
    removeUnrestrictedProducts();

    // Every 500ms run the removeUnrestrictedProducts function
    setInterval(removeUnrestrictedProducts, 200);
  }
})();

function hideCollectionProductCount() {
  if (window.theme.b2b?.isEnabled) {
    const collectionProductCount = document.querySelector(".collection__product-count");

    if (collectionProductCount) {
      collectionProductCount.style.display = "none";
    }
  }
}

hideCollectionProductCount();

function countrySelector() {
  const countryLinks = document.querySelectorAll(".country-selector__link");

  countryLinks.forEach((link) => {
    link.addEventListener("click", function (event) {
      event.preventDefault();
      const countryUrl = this.getAttribute("href");

      if (countryUrl) {
        window.location.href = countryUrl;
      }
    });
  });
}
countrySelector();

// Country Selector Popup functionality
class TriggerPopup {
  constructor(element) {
    this.element = element;
    this.paramName = element.dataset.paramName;
    this.paramValue = element.dataset.paramValue;
  }

  init() {
    const params = new URLSearchParams(window.location.search);
    const currentValue = params.get(this.paramName);
    if (currentValue && currentValue.replace(/\/$/, '') === this.paramValue) {
      this.open();
    }
  }

  open() {
    this.element.style.display = 'block';
    this.bindClose();
  }

  bindClose() {
    this.element.querySelectorAll('.popup-close').forEach(btn => {
      btn.addEventListener('click', () => {
        this.element.style.display = 'none';
      });
    });
  }
}

// Initialize country selector popups
function initCountrySelectorPopups() {
  document.querySelectorAll('trigger-popup').forEach(el => {
    const popupInstance = new TriggerPopup(el);
    popupInstance.init();
  });
}

initCountrySelectorPopups();

// B2B Login- Store the original URL for B2B-customers to return to after login
function fixB2BLoginButton() {
  const storedReturnUrl = sessionStorage.getItem('b2b_return_url');
  
  if (storedReturnUrl) {
    // Find the login button and update its href
    const loginButton = document.querySelector('a[href*="/customer_authentication/login"]');
    
    if (loginButton) {
      // Only use the path part of the URL, not the full URL
      const url = new URL(storedReturnUrl);
      const returnTo = encodeURIComponent(url.pathname + url.search + url.hash);
      loginButton.href = `/customer_authentication/login?return_to=${returnTo}`;
    }
  }
}

// Initialize B2B login button fix
document.addEventListener('DOMContentLoaded', fixB2BLoginButton);

// B2B Login Redirect Logic
function handleB2BLoginRedirect() {
  // Only run on login page when customer is logged in
  if (window.location.pathname.includes('/customer_authentication/login') && window.theme?.b2b?.isEnabled) {
    // Get return_to parameter from URL
    const urlParams = new URLSearchParams(window.location.search);
    const returnTo = urlParams.get('return_to');
    
    if (returnTo && returnTo !== '/') {
      // For B2B customers, redirect to the intended destination
      window.location = decodeURIComponent(returnTo);
    }
  }
}

// Initialize B2B login redirect
document.addEventListener('DOMContentLoaded', handleB2BLoginRedirect);

// CSS styles for subscription recommendations
const SUBSCRIPTION_REC_STYLES = `
  .product-subscription-rec__item {
    display: flex;
    align-items: center;
    width: 100%;
    font-size: var(--font-3);
    padding: 0;
  }
  
  .rc-purchase-option__subscription[rc-selected] .product-subscription-rec__item {
    padding: 0 0 15px;
  }
  .product-subscription-rec__item p {
    margin: 0;
  }
  .product-subscription-rec__item-image img {
    width: 55px;
    height: 100%;
    padding-right: 5px;
  }
  .subscription-change-btn {
    display: flex;
    align-items: center;
    gap: 5px;
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
    font-family: var(--FONT-STACK-BODY);
    font-size: var(--font-2);
  }
  .subscription-change-btn svg {
    width: 12px;
    height: 12px;
  }
  .sub-rec-weight-age-wrapper {
    text-wrap-mode: nowrap;
    padding: 0 9px 0 0;
  }
  .sub-rec-grams-day-wrapper {
    margin: 0 5px 0 0;
  }
  .sub-rec-grams-day-wrapper,
  .sub-rec-price-day-wrapper {
    background: var(--light-light-ivory);
    padding: 0;
    width: 109px;
    min-height: 61px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border: 1px solid var(--soapstone);
    text-wrap-mode: nowrap;
  }
  .calculator-popup {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 10000;
    display: none;
    align-items: center;
    justify-content: center;
  }
  .calculator-popup.open {
    display: flex;
  }
  .calculator-popup-content {
    max-width: 90vw;
    max-height: 90vh;
    overflow: auto;
    position: relative;
  }
  .calculator-popup-close {
    position: absolute;
    top: 15px;
    right: 15px;
    background: none;
    border: none;
    cursor: pointer;
    z-index: 1;
  }
`;


// Get calculator data from session storage
function getCalculatorData() {
  try {
    const data = sessionStorage.getItem('calculator_selection');
    return data ? JSON.parse(data) : null;
  } catch (e) {
    return null;
  }  
}

// Open calculator popup function
function openCalculatorPopup() {
  // Check if popup already exists
  let popupContainer = document.querySelector('.calculator-popup-container');
  let popupOverlay = document.querySelector('.calculator-popup-overlay');
  
  // Create popup structure if it doesn't exist
  if (!popupContainer) {
    // Create overlay
    popupOverlay = document.createElement('div');
    popupOverlay.className = 'calculator-popup-overlay';
    
    // Create container
    popupContainer = document.createElement('div');
    popupContainer.className = 'calculator-popup-container';
    
   
    const header = document.createElement('div');
    header.className = 'popup-link-header';
    header.innerHTML = `
      <button class="closePopupBtn calculator-popup-close" type="button">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1.00022 1L15.0002 15M15 1.00002L1 15" stroke="#202B21" stroke-linecap="round"/>
        </svg>
      </button>
    `;
    
    // Create content area
    const content = document.createElement('div');
    content.className = 'popup-link-content calculator-popup-content';
    
    // Assemble popup
    popupContainer.appendChild(header);
    popupContainer.appendChild(content);
    
    // Add to body
    document.body.appendChild(popupOverlay);
    document.body.appendChild(popupContainer);
  }
  
  // Helper function to get scrollbar width
  const getScrollbarWidth = () => {
    // Create a temporary div to measure scrollbar width
    const outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.overflow = 'scroll';
    outer.style.msOverflowStyle = 'scrollbar';
    document.body.appendChild(outer);
    
    const inner = document.createElement('div');
    outer.appendChild(inner);
    
    const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;
    
    outer.parentNode.removeChild(outer);
    return scrollbarWidth;
  };
  
  // Toggle popup function (defined after popup elements exist)
  const togglePopup = (show) => {
    if (show) {
      // Calculate scrollbar width and set CSS variable
      const scrollbarWidth = getScrollbarWidth();
      document.documentElement.style.setProperty('--scrollbar-width', scrollbarWidth + 'px');
      
      // Add class to body to prevent scroll and compensate for scrollbar
      document.body.classList.add('calculator-popup-open');
      
      // Show overlay first, then trigger animation
      popupOverlay.style.display = 'block';
      // Use requestAnimationFrame to ensure display is set before adding show class
      requestAnimationFrame(() => {
        popupOverlay.classList.add('show');
        popupContainer.classList.add('show');
      });
    } else {
      // Remove show classes for fade out
      popupOverlay.classList.remove('show');
      popupContainer.classList.remove('show');
      // Wait for animation to complete before hiding
      setTimeout(() => {
        popupOverlay.style.display = 'none';
        document.body.classList.remove('calculator-popup-open');
        document.documentElement.style.removeProperty('--scrollbar-width');
      }, 300);
    }
  };
  
  // Bind close handlers if not already bound
  const closeBtn = popupContainer.querySelector('.closePopupBtn');
  if (!closeBtn.hasAttribute('data-handlers-bound')) {
    closeBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      togglePopup(false);
    });
    popupOverlay.addEventListener('click', (e) => {
      // Only close if clicking the overlay itself, not the container
      if (e.target === popupOverlay) {
        togglePopup(false);
      }
    });
    
    // Close on Escape key
    const escapeHandler = function(e) {
      if (e.key === 'Escape' && popupContainer.classList.contains('show')) {
        togglePopup(false);
      }
    };
    document.addEventListener('keydown', escapeHandler);
    closeBtn.setAttribute('data-handlers-bound', 'true');
  }
  
  // Find calculator section on the page
  const calculatorSection = document.querySelector('[id^="Product-Page-Calculator--"]');
  const content = popupContainer.querySelector('.calculator-popup-content');
  
  if (calculatorSection && content) {
    // Clone the calculator section
    const clonedSection = calculatorSection.cloneNode(true);
    
    // Remove loading class and show content
    clonedSection.classList.remove('loading');
    
    // Clear existing content and add cloned calculator
    content.innerHTML = '';
    content.appendChild(clonedSection);
    
    // Re-initialize any scripts or components in the cloned section
    // This might be needed if the calculator has custom web components
    const productPageCalculator = clonedSection.querySelector('product-page-calculator');
    if (productPageCalculator) {
      // Trigger any initialization if needed
      const event = new CustomEvent('calculator-popup-opened', { detail: { element: productPageCalculator } });
      document.dispatchEvent(event);
    }
    
    // Open the popup with smooth animation
    togglePopup(true);
  } else {
    console.warn('Calculator section not found on page');
  }
}

function getCurrentCalculatorItem() {
  const productHandle = window.location.pathname.split('/products/')[1];
  
  fetch(`/products/${productHandle}.js`)
    .then(res => res.json())
    .then(product => {
      const calculatorDataElement = document.querySelector('[data-product-calculator-json]');
      const sessionData = getCalculatorData();
      
      if (calculatorDataElement && sessionData) {
        const calculatorData = JSON.parse(calculatorDataElement.textContent);

        if (!calculatorData) return;

        // Helper to get itemTags
        const getItemTags = (item) => item.pt ? item.pt.split(',').map(tag => tag.trim()) : [];

        // Find matching items based on tags, age, and weight
        const matchingItems = calculatorData.items.filter(item => {
          const itemTags = getItemTags(item);
          const hasMatchingTag = itemTags.some(tag => product.tags.includes(tag));
          const ageMatches = item.a === sessionData.age;
          const weightMatches = item.w === sessionData.weight;
          return hasMatchingTag && ageMatches && weightMatches;
        });

        // Count matching tags for each item
        const tagMatchCounts = matchingItems.map(item => {
          const itemTags = getItemTags(item);
          const matchingTagCount = itemTags.filter(tag => product.tags.includes(tag)).length;
          return { item, matchingTagCount };
        });

        // Detect if this is a cat meal (has cat-meal- tags)
        const isCatMeal = matchingItems.some(item => {
          const itemTags = getItemTags(item);
          return itemTags.some(tag => tag.startsWith('cat-meal-') || tag.startsWith('pate-meal-'));
        });

        // Detect if this is a dog pate (has dog-pate- tags)
        const isDogPate = matchingItems.some(item => {
          const itemTags = getItemTags(item);
          return itemTags.some(tag => tag.startsWith('dog-pate-'));
        });
        
        // Detect if this is a cat pate (has cat-pate- or pate-cat- tags)
        const isCatPate = matchingItems.some(item => {
          const itemTags = getItemTags(item);
          return itemTags.some(tag => tag.startsWith('cat-pate-') || tag.startsWith('pate-cat-'));
        });
        
        let selectedItem = null;
        
        if (isCatMeal) {
          const oneFiveKgItem = matchingItems.find(item => 
            item.ufc === false && 
            item.pt?.includes('-1-5')
          );

          const threeKgItem = matchingItems.find(item => 
            item.ufc === false && 
            item.pt?.includes('-3')
          );

          const twelveKgItem = matchingItems.find(item => 
            item.ufc === true
          );
          
          selectedItem = oneFiveKgItem || threeKgItem || twelveKgItem;
        } else if (isDogPate) {
          // Dog pate: bundle (400g x 6) = ufc === true
          // Single 400g = no calculator data or ufc === false (will use default 1 week)
          const bundlePateItem = matchingItems.find(item => 
            item.ufc === true
          );
          selectedItem = bundlePateItem || null;
        } else if (isCatPate) {
          const catPateItem = matchingItems.find(item => 
            item.ufc === true
          );
          selectedItem = catPateItem || null;
        } else {
          // Select correct item: big bag = ufc = true 
          // Small bag = 1 tag + ufc = false
          const bigBagItem = tagMatchCounts.find(({item, matchingTagCount}) => 
            matchingTagCount >= 2 && item.ufc === true
          );
          const smallBagItem = tagMatchCounts.find(({item, matchingTagCount}) => 
            matchingTagCount === 1 && item.ufc === false
          );
          selectedItem = bigBagItem ? bigBagItem.item : smallBagItem ? smallBagItem.item : null;
        }
        
        window.currentCalculatorItem = selectedItem;
        // console.log('Selected calculator item:', window.currentCalculatorItem);
      }
    });
}

// Inject styles into shadow DOM (cached)
function injectSubscriptionStyles(shadow) {
  if (shadow.querySelector('#subscription-rec-styles')) return;
  
  const styleEl = document.createElement('style');
  styleEl.id = 'subscription-rec-styles';
  styleEl.textContent = SUBSCRIPTION_REC_STYLES;
  shadow.appendChild(styleEl);
}

// Add or update subscription recommendation in widget
function addSubscriptionRec() {
  // Early validation - consolidate all checks
  const widget = document.querySelector("recharge-subscription-widget");
  const shadow = widget?.shadowRoot;
  const subscriptionOption = shadow?.querySelector('.rc-purchase-option__subscription');
  const template = document.getElementById('subscription-rec-template');
  const calculatorData = getCalculatorData();
  const currentItem = window.currentCalculatorItem;
  
  if (!widget || !shadow || !subscriptionOption || !template || !calculatorData || !currentItem) {
    return false;
  }

  // Check if already applied
  if (subscriptionOption.hasAttribute('data-subscription-rec-applied')) {
    return true;
  }

  // Check if recommendation already exists and if it needs updating
  const existingRec = subscriptionOption.querySelector('.product-subscription-rec__item');
  if (existingRec) {
    // Check if the existing recommendation is based on the same calculator data
    const existingData = existingRec.getAttribute('data-calculator-timestamp');
    const currentData = calculatorData.timestamp;
    
    // If the data hasn't changed, don't update (prevents duplicates)
    if (existingData === currentData) {
      subscriptionOption.setAttribute('data-subscription-rec-applied', 'true');
      return true;
    }
    
    // Data has changed, remove existing recommendation to allow update
    subscriptionOption.querySelectorAll('.product-subscription-rec__item')
      .forEach(rec => rec.remove());
  }

  // Inject styles (cached)
  injectSubscriptionStyles(shadow);

  // Clone template
  const recItem = template.content.cloneNode(true)
    .querySelector('.product-subscription-rec__item');
  
  // Add timestamp to track when this recommendation was created
  recItem.setAttribute('data-calculator-timestamp', calculatorData.timestamp);
  
  
  // Format price correctly for the store's currency using currentCalculatorItem
  // Detect market from hostname to show correct price
  let priceValue = null;
  const hostname = window.location.hostname;
  
  // Debug logging to see what's happening
  console.log('Price detection debug:', {
    hostname,
    currentItem,
    availablePrices: {
      dkk: currentItem?.ppdDKK,
      sek: currentItem?.ppdSEK,
      nok: currentItem?.ppdNOK,
      eur: currentItem?.ppdEUR,
      gbp: currentItem?.ppdGBP
    }
  });
  
  if (hostname.includes('.dk')) {
    priceValue = currentItem?.ppdDKK;
  } else if (hostname.includes('.se')) {
    priceValue = currentItem?.ppdSEK;
  } else if (hostname.includes('.no')) {
    priceValue = currentItem?.ppdNOK;
  } else if (hostname.includes('.de')) {
    priceValue = currentItem?.ppdEUR;
  } else if (hostname.includes('.co.uk')) {
    priceValue = currentItem?.ppdGBP;
  } else {
    // Default fallback
    priceValue = currentItem?.ppdEUR;
  }
  
  console.log('Selected price:', priceValue);
  let formattedPrice = 'Price';
  
  if (priceValue) {
    const normalizedPrice = typeof priceValue === 'string' 
      ? priceValue.replace(',', '.') 
      : priceValue.toString();
    const priceInCents = parseFloat(normalizedPrice) * 100;
    formattedPrice = formatMoney(priceInCents, window.theme.moneyFormat);
  }
  
  // Get the weight images
  const customerWeight = parseInt(calculatorData.weight.replace(' kg', ''));
  const weightMapping = JSON.parse(
    document.querySelector('[data-weight-image-mapping]').textContent
  );
  const availableWeights = Object.keys(weightMapping)
    .map(w => parseInt(w.replace(' kg', '')))
    .sort((a, b) => a - b);
  
  // Find closest weight (round down)
  const closestWeight = availableWeights
    .filter(w => w <= customerWeight)
    .pop() || availableWeights[0];
  
  const imageUrl = weightMapping[`${closestWeight} kg`];
  
  // Update content with dynamic data
  const elements = {
    image: recItem.querySelector('.product-subscription-rec__item-image'),
    weight: recItem.querySelector('.sub-rec-weight'),
    age: recItem.querySelector('.sub-rec-age'),
    grams: recItem.querySelector('.sub-rec-grams'),
    price: recItem.querySelector('.sub-rec-price'),
  };
  
  elements.image.innerHTML = `<img src="${imageUrl}" alt="Weight ${calculatorData.weight}">`;
  
  // If it's a cat product - hide image
  const isCatProduct = currentItem?.pt?.match(/(cat|pate)-(meal|cat|pate)-/);
  if (isCatProduct) {
    elements.image.style.display = 'none';
    recItem.querySelector('.subscription-change-btn')?.style.setProperty('padding-right', '15px');
  }
  elements.weight.textContent = calculatorData.weight || 'Weight';
  elements.age.textContent = calculatorData.age || 'Age';
  elements.grams.textContent = currentItem?.gpd ? `${currentItem.gpd} g` : 'Grams';
  elements.price.textContent = formattedPrice;
  
  // Insert after the label but before the sub-container
  const label = subscriptionOption.querySelector('.rc-purchase-option__label');
  label.insertAdjacentElement('afterend', recItem);
  
  // Add click handler to subscription-change-btn if it exists
  const changeBtn = recItem.querySelector('.subscription-change-btn');
  if (changeBtn && !changeBtn.hasAttribute('data-click-handler-applied')) {
    changeBtn.addEventListener('click', function() {
      openCalculatorPopup();
    });
    changeBtn.setAttribute('data-click-handler-applied', 'true');
  }
  
  // Mark as applied to prevent re-application
  subscriptionOption.setAttribute('data-subscription-rec-applied', 'true');
  return true;
}

function updateWeeksSelector() {
  const widget = document.querySelector("recharge-subscription-widget");
  const shadow1 = widget?.shadowRoot;
  if (!shadow1) return false;

  // access select in second shadow root
  const innerHost = shadow1.querySelector("rc-selling-plans");
  const shadow2 = innerHost?.shadowRoot;
  if (!shadow2) return false;

  const select = shadow2.querySelector("select.rc-plans-dropdown__select");
  if (!select) return false;

  // Get current calculator data to check timestamp
  const calculatorData = getCalculatorData();
  const currentTimestamp = calculatorData?.timestamp;
  
  // Check if already applied and if data has changed
  if (select.hasAttribute('data-weeks-selector-applied')) {
    const existingTimestamp = select.getAttribute('data-calculator-timestamp');
    // If the data hasn't changed, don't update (prevents unnecessary updates)
    if (existingTimestamp === currentTimestamp) {
      return true;
    }
    // Data has changed, remove the flag to allow update
    select.removeAttribute('data-weeks-selector-applied');
  }

  // set selected index dynamically using currentCalculatorItem data
  const currentItem = window.currentCalculatorItem;
  
  // Check if this is a single dog pate (no calculator data) - use 1 week (first option)
  // Check calculator data element for dog-pate tags
  const calculatorDataElement = document.querySelector('[data-product-calculator-json]');
  let isSingleDogPate = false;
  if (!currentItem && calculatorDataElement) {
    try {
      const calculatorData = JSON.parse(calculatorDataElement.textContent);
      const productTags = calculatorData.tags ? calculatorData.tags.split(',').map(tag => tag.trim()) : [];
      isSingleDogPate = productTags.some(tag => tag.startsWith('dog-pate-'));
    } catch (e) {
      // Ignore parse errors
    }
  }
  
  if (isSingleDogPate) {
    select.selectedIndex = 0; // First option = 1 week
    select.dispatchEvent(new Event("input", { bubbles: true }));
    select.dispatchEvent(new Event("change", { bubbles: true }));
    select.setAttribute('data-weeks-selector-applied', 'true');
    if (currentTimestamp) {
      select.setAttribute('data-calculator-timestamp', currentTimestamp);
    }
    return true;
  }

  if (currentItem && currentItem.dpb) {
    try {
      // Round days_per_bag to remove decimals
      const daysPerBag = Math.round(currentItem.dpb);

      // Convert to weeks - round down if decimal, round up if whole number
      const weeksFloat = daysPerBag / 7;
      const weeks = weeksFloat % 1 === 0 ? Math.ceil(weeksFloat) : Math.floor(weeksFloat);

      // Limit to 1–14 weeks (since options only go to 14 weeks)
      const chosenWeeks = Math.min(Math.max(weeks, 1), 14);
      select.selectedIndex = chosenWeeks - 1;

      console.log('Days per bag:', currentItem.dpb, 'Rounded:', daysPerBag, 'Weeks:', weeks, 'Selected index:', chosenWeeks - 1);

      // Trigger events so widget reacts
      select.dispatchEvent(new Event("input", { bubbles: true }));
      select.dispatchEvent(new Event("change", { bubbles: true }));
      
      // Mark as applied and store timestamp to track when this was set
      select.setAttribute('data-weeks-selector-applied', 'true');
      if (currentTimestamp) {
        select.setAttribute('data-calculator-timestamp', currentTimestamp);
      }
      return true;
    } catch (e) {
      console.warn("Invalid calculator_selection data:", e);
      return false;
    }
  }
  
  return false;
}

// Track interval IDs to prevent duplicates
let subscriptionRecIntervalId = null;
let weeksSelectorIntervalId = null;

// Watch for subscription recommendation element and apply when ready
function watchForSubscriptionRec() {
  let intervalId = setInterval(() => {
    const widget = document.querySelector("recharge-subscription-widget");
    const shadow = widget?.shadowRoot;
    const subscriptionOption = shadow?.querySelector('.rc-purchase-option__subscription');
    
    // Check if widget is ready and recommendation hasn't been applied yet
    if (subscriptionOption && !subscriptionOption.hasAttribute('data-subscription-rec-applied')) {
      getCurrentCalculatorItem();
      
      const success = addSubscriptionRec();
      if (success) {
        clearInterval(intervalId);
        subscriptionRecIntervalId = null;
      }
    }
  }, 10);
  
  // Stop after 2 seconds if not found
  setTimeout(() => {
    clearInterval(intervalId);
    subscriptionRecIntervalId = null;
  }, 2000);
  
  return intervalId;
}

// Watch for weeks selector and apply when ready
function watchForWeeksSelector() {
  let intervalId = setInterval(() => {
    const widget = document.querySelector("recharge-subscription-widget");
    const shadow1 = widget?.shadowRoot;
    if (!shadow1) return;
    
    const innerHost = shadow1.querySelector("rc-selling-plans");
    const shadow2 = innerHost?.shadowRoot;
    if (!shadow2) return;
    
    const select = shadow2.querySelector("select.rc-plans-dropdown__select");
    
    // Check if selector is ready - updateWeeksSelector will check timestamp internally
    if (select) {
      getCurrentCalculatorItem();
      const success = updateWeeksSelector();
      // Clear interval if successfully applied (updateWeeksSelector checks timestamp internally)
      if (success) {
        const calculatorData = getCalculatorData();
        const currentTimestamp = calculatorData?.timestamp;
        const existingTimestamp = select.getAttribute('data-calculator-timestamp');
        // Only clear if timestamp matches (meaning it's applied and up to date)
        if (currentTimestamp && existingTimestamp === currentTimestamp) {
          clearInterval(intervalId);
          weeksSelectorIntervalId = null;
        }
      }
    }
  }, 10);
  
  // Stop after 2 seconds if not found
  setTimeout(() => {
    clearInterval(intervalId);
    weeksSelectorIntervalId = null;
  }, 2000);
  
  return intervalId;
}

// Start both watchers
function startSubscriptionWatchers() {
  // Clear existing intervals if any
  if (subscriptionRecIntervalId) {
    clearInterval(subscriptionRecIntervalId);
  }
  if (weeksSelectorIntervalId) {
    clearInterval(weeksSelectorIntervalId);
  }
  
  // Start new watchers
  subscriptionRecIntervalId = watchForSubscriptionRec();
  weeksSelectorIntervalId = watchForWeeksSelector();
}

function subscribeToShadowRootChanges() { 
  // Check if subscription recommendation is enabled
  if (!window.theme?.settings?.showSubscriptionRecommendation) {
    return;
  }
  
  const shadow = document.querySelector("recharge-subscription-widget")?.shadowRoot;
  if (!shadow) return;

  shadow.addEventListener('input', function (event) {
    if (event.target.value === 'subscription') {
      // Check setting again before proceeding
      if (!window.theme?.settings?.showSubscriptionRecommendation) {
        return;
      }
      
      // Reset applied flags and restart watchers when switching to subscription
      const subscriptionOption = shadow.querySelector('.rc-purchase-option__subscription');
      if (subscriptionOption) {
        subscriptionOption.removeAttribute('data-subscription-rec-applied');
      }
      
      const innerHost = shadow.querySelector("rc-selling-plans");
      const shadow2 = innerHost?.shadowRoot;
      if (shadow2) {
        const select = shadow2.querySelector("select.rc-plans-dropdown__select");
        if (select) {
          select.removeAttribute('data-weeks-selector-applied');
        }
      }
      
      startSubscriptionWatchers();
    }
  });
}

// Personalized subscription based on product calculator
document.addEventListener('DOMContentLoaded', function() {
  // Check if subscription recommendation is enabled
  if (!window.theme?.settings?.showSubscriptionRecommendation) {
    return; // Exit early if feature is disabled
  }
  
  // Start watchers to apply changes when widget is ready
  startSubscriptionWatchers();
  
  // Listen for calculator completion - reset flags and restart watchers
  document.addEventListener('calculatorCompleted', function(event) {
    // Check setting again in case it changed
    if (!window.theme?.settings?.showSubscriptionRecommendation) {
      return;
    }
    
    const widget = document.querySelector("recharge-subscription-widget");
    const shadow = widget?.shadowRoot;
    if (shadow) {
      const subscriptionOption = shadow.querySelector('.rc-purchase-option__subscription');
      if (subscriptionOption) {
        subscriptionOption.removeAttribute('data-subscription-rec-applied');
      }
      
      const innerHost = shadow.querySelector("rc-selling-plans");
      const shadow2 = innerHost?.shadowRoot;
      if (shadow2) {
        const select = shadow2.querySelector("select.rc-plans-dropdown__select");
        if (select) {
          select.removeAttribute('data-weeks-selector-applied');
        }
      }
    }
    
    startSubscriptionWatchers();
  });

  subscribeToShadowRootChanges();
});

function handleMemberGetMemberAccount() {
  // Skip if in design mode or not on member-get-member page
  if (window.Shopify?.designMode || !window.location.pathname.includes('/pages/member-get-member')) {
    return;
  }

  document.addEventListener('click', function(e) {
    const anchor = e.target.closest('a');
    if (!anchor?.href) return;

    // Only intercept links to MGM account page
    const isMgmLink = anchor.href.includes('/pages/member-get-member-account') || anchor.href.includes('/pages/mgm-account');
    if (!isMgmLink) return;

    // If not logged in, redirect to login page
    const isLoggedIn = window.theme?.settings?.customerLoggedIn || false;
    if (!isLoggedIn) {
      e.preventDefault();
      window.location.href = `/account/login?return_to=${encodeURIComponent(anchor.href)}`;
    }
  }, true);
}
function handleRecommendLinkRedirect() {
  if (window.Shopify?.designMode) {
    return;
  }

  // Check if customer is logged in
  const isLoggedIn = window.theme?.settings?.customerLoggedIn || false;
  if (!isLoggedIn) {
    return;
  }

  // Find all links in secondary desktop menu
  const secondaryMenuLinks = document.querySelectorAll('.secondary_desktop_linklist .navlink_secondary_link');
  
  secondaryMenuLinks.forEach(link => {
    // Only change links that point to member-get-member page
    if (link.href.includes('/pages/member-get-member') && 
        !link.href.includes('/pages/member-get-member-account')) {
      link.href = '/pages/member-get-member-account';
    }
  });
}

// Initialize on page load
(function() {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleMemberGetMemberAccount);
    document.addEventListener('DOMContentLoaded', handleRecommendLinkRedirect);
  } else {
    handleMemberGetMemberAccount();
    handleRecommendLinkRedirect();
  }
})();


// Make Rebuy cart qty label editable (overlay input, do not touch label contents)
(function () {
  "use strict";

  // Global flag to prevent multiple simultaneous cart updates
  let isUpdatingQuantity = false;

  // Extract the quantity number from the label without modifying the DOM
  function getQuantityFromLabel(label) {
    // Read quantity from existing label text nodes (no DOM changes)
    // Filter to get only text nodes (not element nodes like the sr-only span)
    const text = Array.from(label.childNodes)
      .filter((n) => n.nodeType === Node.TEXT_NODE) // Only grab raw text, not HTML elements
      .map((n) => (n.textContent || "").trim()) // Clean up whitespace from each text node
      .join("") // Combine all text nodes into one string
      .trim(); // Final trim to remove any leading/trailing spaces

    // Convert the text to a number
    const qty = parseInt(text, 10);
    // Return the number only if it's valid, otherwise return null
    return Number.isFinite(qty) ? qty : null;
  }

  // Find the product handle by traversing up the DOM tree
  function getHandleForLabel(label) {
    // Find the parent cart item container
    const lineItem = label.closest(".rebuy-cart__flyout-item");
    if (!lineItem) return null; // make sure we found the container

    // Find the product link inside the cart item
    const productLink = lineItem.querySelector('a[href*="/products/"]');
    // Extract the handle from the URL (e.g., /products/my-product?variant=123 -> my-product)
    const handle = productLink?.href?.split("/products/")[1]?.split("?")[0];
    return handle || null; // Return the handle or null if not found
  }

  // Update the cart quantity
  async function updateCartQuantity(productHandle, newQty) {
    // Get Rebuy's internal cart data
    const rebuyCart = window.Rebuy?.Cart?.cart;
    if (!rebuyCart?.items) return false; // make sure cart data exists

    // Find the cart item that matches our product handle
    const matchingItem = rebuyCart.items.find((item) => item.handle === productHandle);
    if (!matchingItem) {
      console.error("Could not find matching cart item (by handle).");
      return false; // Can't update if we can't find the item
    }

    try {
      // Call Shopify's cart change endpoint
      const response = await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: matchingItem.key, // Use the cart item's key (not variant ID)
          quantity: newQty, // New quantity to set
        }),
      });

      const data = await response.json();

      if (!response.ok || data?.status === "bad_request") {
        console.error("Cart change failed:", data?.message || data);
        return false;
      }

      return true;

    } catch (err) {
      console.error("Error updating cart:", err);
      return false;
    }
  }

  // Add CSS styles to the page (only once)
  function ensureOnceStyles() {
    // Don't add styles if they already exist
    if (document.getElementById("rebuy-qty-edit-style")) return;

    // Create a style tag
    const style = document.createElement("style");
    style.id = "rebuy-qty-edit-style"; // Give it an ID so we can check if it exists
    style.textContent = `
      .rebuy-qty-input-overlay {
        position: absolute; /* Position over the number without affecting layout */
        z-index: 9999; /* Make sure it appears on top */
        display: block;
        width: 22px; /* Match the label size */
        height: 24px;
        line-height: 24px; /* Center text vertically */
        text-align: center; /* Center text horizontally */
        border: none; /* No border */
        border-radius: 0; /* No rounded corners */
        padding: 0; /* No padding */
        margin: 0; /* No margin */
        font-size: 12px; /* Match Rebuy's font size */
        font-weight: bold; /* Match Rebuy's font weight */
        font-family: inherit; /* Use the same font as the label */
        color: #202b21; /* Match Rebuy's text color */
        background: #f9f1e1; /* Solid background to cover the number underneath */
        box-sizing: border-box; /* Include padding/border in width/height */
        -moz-appearance: textfield; /* Firefox: remove spinner buttons */
      }
      /* Remove spinner buttons in Chrome/Safari/Edge */
      .rebuy-qty-input-overlay::-webkit-inner-spin-button,
      .rebuy-qty-input-overlay::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
    `;
    document.head.appendChild(style); // Add the styles to the page
  }

  // Remove the overlay input and clean up
  function removeExistingOverlay(label) {
    // Find any existing overlay input inside this label
    const existing = label.querySelector(":scope > .rebuy-qty-input-overlay");
    if (existing) existing.remove();
    
    label.classList.remove("rebuy-qty-editing");
    
    // Reset the position style we might have added
    label.style.position = "";
  }

  // Main function: make all quantity labels editable
  function setupEditableQuantities() {
    // Make sure our CSS is loaded
    ensureOnceStyles();

    // Find all quantity labels in the Rebuy cart
    const labels = document.querySelectorAll(".rebuy-cart__flyout-item-quantity-widget-label");

    // Loop through each label and set up click handlers
    labels.forEach((label) => {
      // Skip if we've already set up this label (prevents duplicate event listeners)
      if (label.dataset.editableSetup) return;
      label.dataset.editableSetup = "true"; // Mark as setup

      // Change cursor to text cursor to indicate it's clickable
      label.style.cursor = "text";

      label.addEventListener("click", (e) => {
        // Don't start editing if we're currently updating the cart
        if (isUpdatingQuantity) return;
        
        // Don't start editing if user clicked the screen reader text
        if (e.target.classList.contains("sr-only")) return;

        // Don't start editing if there's already an input overlay
        if (label.querySelector(":scope > .rebuy-qty-input-overlay")) return;

        // Get the current quantity from the label
        const currentQty = getQuantityFromLabel(label);
        if (!currentQty) return; // Can't edit if we can't read the quantity

        // Get the product handle
        const handle = getHandleForLabel(label);
        if (!handle) return; // Can't update cart without the handle

        // Make sure the label can host an absolutely positioned child
        const computedPos = window.getComputedStyle(label).position;
        if (computedPos === "static") label.style.position = "relative";

        // Create the overlay input element
        const input = document.createElement("input");
        input.type = "number";
        input.inputMode = "numeric"; // Mobile: show numeric keyboard
        input.pattern = "[0-9]*"; // iOS: show numeric keyboard (not standard keyboard)
        input.min = "1"; // Minimum quantity is 1
        input.value = String(currentQty); // Pre-fill with current quantity
        input.className = "rebuy-qty-input-overlay";

        input.style.left = "50%";
        input.style.top = "50%";
        input.style.transform = "translate(-50%, -50%)";

        // Add the input to the label (as an overlay, not replacing anything)
        label.appendChild(input);

        // Focus the input and select all text (so user can just start typing)
        input.focus();
        input.select();

        // Helper function to remove the overlay and clean up
        const finish = () => removeExistingOverlay(label);

        // Save the new quantity when the user is done editing
        const save = async () => {
          // Safety check: make sure the input is still in the DOM
          if (!label.contains(input)) return;

          // Get the new quantity the user typed
          const newQty = parseInt(input.value, 10);

          // Validate: must be a valid number and at least 1
          if (!Number.isFinite(newQty) || newQty < 1) {
            finish(); // Invalid input, just close the overlay
            return;
          }
          
          // If quantity didn't change, just close the overlay
          if (newQty === currentQty) {
            finish();
            return;
          }

          // Set flag to prevent other updates while this one is processing
          isUpdatingQuantity = true;
          
          // Update the cart via API
          const success = await updateCartQuantity(handle, newQty);
          
          // Clear the flag
          isUpdatingQuantity = false;

          // Always remove the overlay (whether success or failure)
          // We let Rebuy handle updating the displayed number
          finish();

          // If the update succeeded, Rebuy will re-render the cart
          if (success) {
            // Wait for Rebuy to finish re-rendering, then re-setup event listeners
            setTimeout(() => {
              // Clear all the "already setup" flags
              document
                .querySelectorAll(".rebuy-cart__flyout-item-quantity-widget-label")
                .forEach((el) => delete el.dataset.editableSetup);
              
              // Re-setup editable quantities on the fresh DOM
              setupEditableQuantities();
            }, 300);
          }
        };

        // When user clicks away from the input, save the changes
        input.addEventListener("blur", save);

        // Handle keyboard shortcuts
        input.addEventListener("keydown", (ev) => {
          if (ev.key === "Enter") {
            // Enter key: save and close
            ev.preventDefault();
            input.blur(); // Trigger the blur event which calls save()
          } else if (ev.key === "Escape") {
            // cancel and close without saving
            ev.preventDefault();
            finish();
          }
        });
      });
    });
  }

  document.addEventListener("rebuy:cart.ready", setupEditableQuantities);

  // When Rebuy updates the cart (from +/- buttons, for example), re-setup
  document.addEventListener("rebuy:cart.change", function () {
    // Don't re-setup if we triggered the change (to avoid conflicts)
    if (isUpdatingQuantity) return;

    // Wait a bit for the DOM to settle
    setTimeout(() => {
      // Clear all the "already setup" flags
      document
        .querySelectorAll(".rebuy-cart__flyout-item-quantity-widget-label")
        .forEach((el) => delete el.dataset.editableSetup);

      // Re-setup editable quantities
      setupEditableQuantities();
    }, 200);
  });
})();

/* =========================================================================
   Recharge bundle — Rebuy cart grouping
   -------------------------------------------------------------------------
   Groups cart lines that share a `_bundle_id` (written by the recharge-bundle
   widget) into one visual bundle card in the Rebuy Smart Cart:
     • header: bundle product title + image (fetched by handle) + frequency
     • children listed inside; per-child quantity/remove hidden
     • one "Remove bundle" deletes all siblings (whole-bundle only)
     • price: the actual summed child line prices (no discount applied yet)
   Mirrors the existing Rebuy DOM-decoration pattern (index-aligned cart.items
   ↔ .rebuy-cart__flyout-item) and re-runs on every Rebuy render.
   ========================================================================= */
(function () {
  const RB_PRODUCT_CACHE = {};

  function fetchBundleProduct(handle) {
    if (!handle) return Promise.resolve(null);
    if (!RB_PRODUCT_CACHE[handle]) {
      RB_PRODUCT_CACHE[handle] = fetch("/products/" + handle + ".js")
        .then((r) => (r.ok ? r.json() : null))
        .catch(() => null);
    }
    return RB_PRODUCT_CACHE[handle];
  }

  function ensureBundleStyles() {
    if (document.getElementById("rb-cart-bundle-style")) return;
    const style = document.createElement("style");
    style.id = "rb-cart-bundle-style";
    // In-place decoration only: we add classes to Rebuy's OWN line items and
    // inject a header inside the first one. We never add foreign nodes to, or
    // move nodes within, ul[data-smartcart-items] — doing so breaks Rebuy's
    // own list rendering on subsequent AJAX updates.
    style.textContent = `
      .rebuy-cart__flyout-item.rb-bundle-item { border-left: 1px solid var(--soapstone, #d9cfbb); border-right: 1px solid var(--soapstone, #d9cfbb); padding-left: 12px; padding-right: 12px; }
      .rebuy-cart__flyout-item.rb-bundle-first { border-top: 1px solid var(--soapstone, #d9cfbb); border-top-left-radius: 6px; border-top-right-radius: 6px; padding-top: 10px; flex-wrap: wrap; }
      .rb-bundle-head { flex: 0 0 100%; order: -1; }
      .rebuy-cart__flyout-item.rb-bundle-last { border-bottom: 1px solid var(--soapstone, #d9cfbb); border-bottom-left-radius: 6px; border-bottom-right-radius: 6px; padding-bottom: 10px; }
      .rebuy-cart__flyout-item.rb-bundle-removing,
      .rebuy-cart__flyout-item.rb-bundle-merged { display: none !important; }
      .rebuy-cart__flyout-item.rb-bundle-item .rebuy-cart__flyout-item-remove,
      .rebuy-cart__flyout-item.rb-bundle-item .rebuy-cart__flyout-item-properties,
      .rebuy-cart__flyout-item.rb-bundle-item .rebuy-cart__flyout-item-quantity-widget-button { display: none !important; }
      .rebuy-cart__flyout-item.rb-bundle-item .rebuy-cart__flyout-item-quantity-widget { pointer-events: none; }
      .rb-bundle-head { display: flex; align-items: flex-start; gap: 10px; padding-bottom: 10px; margin-bottom: 10px; border-bottom: 1px solid #ECE4D5; }
      .rb-bundle-head__image { width: 40px; height: 40px; object-fit: cover; border-radius: 4px; flex: 0 0 auto; }
      .rb-bundle-head__info { display: flex; flex-direction: column; gap: 2px; flex: 1 1 auto; min-width: 0; }
      .rb-bundle-head__title { font-weight: 600; color: var(--web-green-dark, #202b21); }
      .rb-bundle-head__meta { font-size: .8em; opacity: .75; }
      .rb-bundle-head__remove { align-self: flex-start; background: none; border: 0; padding: 0; font-size: .75em; text-decoration: underline; cursor: pointer; color: inherit; opacity: .7; }
      .rb-bundle-head__price { font-weight: 600; white-space: nowrap; color: var(--web-green-dark, #202b21); }
    `;
    document.head.appendChild(style);
  }

  function rbGetCart() {
    return (window.Rebuy && window.Rebuy.Cart) ? window.Rebuy.Cart.cart : null;
  }

  // Localized "Remove bundle" label from the theme's JS strings, with a guard
  // for the "translation missing" placeholder if the key isn't added yet.
  function rbRemoveLabel() {
    const s = window.theme && window.theme.strings && window.theme.strings.bundleRemove;
    if (s && s.indexOf("translation missing") === -1) return s;
    return "Remove bundle";
  }

  // Best-effort header metadata (handle / plan / price) for a token, from the
  // live cart. The card itself is built from the DOM, so a stale/empty cart
  // here only means a temporarily generic header — never a missing card.
  function rbGroupInfo(token) {
    const cart = rbGetCart();
    if (!cart || !cart.items) return {};
    let info = null;
    cart.items.forEach((it) => {
      const bid = it.properties && it.properties._bundle_id;
      if (!bid || rbToken(bid) !== token) return;
      if (!info) info = { handle: it.properties._bundle_product, plan: null, total: 0 };
      info.total += it.final_line_price || 0;
      if (!info.plan) {
        // Prefer the localized label carried on the line; fall back to the
        // (English) selling-plan name from Recharge.
        info.plan = (it.properties && it.properties._bundle_freq_label)
          || (it.selling_plan_allocation && it.selling_plan_allocation.selling_plan.name)
          || null;
      }
    });
    return info || {};
  }

  // Remove every line whose _bundle_id matches this token. The cart global is
  // current at click time (a user action after render), so keys are reliable.
  // Optimistically hides the group's lines (CSS class only — no node removal),
  // then lets Rebuy re-render and reconcile.
  function removeBundleByToken(token) {
    const cart = rbGetCart();
    if (!cart || !cart.items) return;
    const updates = {};
    cart.items.forEach((it) => {
      const bid = it.properties && it.properties._bundle_id;
      if (bid && rbToken(bid) === token) updates[it.key] = 0;
    });
    if (!Object.keys(updates).length) return;
    document.querySelectorAll('.rb-bundle-item[data-rb-token="' + token + '"]')
      .forEach((el) => el.classList.add("rb-bundle-removing"));
    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ updates }),
    }).catch(() => {});
  }

  // Sanitize a property value the same way Rebuy does when it stamps it as a
  // CSS class (alphanumeric only, lowercased) — so a cart _bundle_id matches
  // the `property-_bundle_id:<token>` class on its line element.
  function rbToken(v) {
    return String(v == null ? "" : v).toLowerCase().replace(/[^a-z0-9]/g, "");
  }

  // EF-462: a single-variant recipe is added as two lines (`_bundle_unit` 1/2 and
  // 2/2, see recharge-bundle.js recipeParts) so the checkout's recurring sentence
  // stays generic. Show them as ONE row, as before the split: the first half
  // carries the summed quantity, the others are hidden (class only — Rebuy owns
  // the nodes). The price on a row is per unit, so it needs no change.
  function rbCollapseSplitRows(token, items) {
    const halves = items.filter((el) => el.classList.contains("property-key-_bundle_unit"));
    if (halves.length < 2) return;
    const cart = rbGetCart();
    if (!cart || !cart.items) return;
    const total = cart.items.reduce((sum, it) => {
      const p = it.properties || {};
      return p._bundle_unit && rbToken(p._bundle_id) === token ? sum + it.quantity : sum;
    }, 0);
    if (!total) return;
    halves.slice(1).forEach((el) => el.classList.add("rb-bundle-merged"));
    const label = halves[0].querySelector(".rebuy-cart__flyout-item-quantity-widget-label");
    if (!label) return;
    const text = [...label.childNodes].reverse().find((node) => node.nodeType === 3 && node.textContent.trim());
    if (text) text.textContent = " " + total + " ";
  }

  // Read a line element's own _bundle_id token from its classes.
  function rbDomToken(el) {
    const cls = el.classList;
    for (let i = 0; i < cls.length; i++) {
      if (cls[i].indexOf("property-_bundle_id:") === 0) {
        return cls[i].slice("property-_bundle_id:".length);
      }
    }
    return null;
  }

  // Decorate bundle groups IN PLACE — no foreign nodes in, and no moving of
  // nodes within, ul[data-smartcart-items] (that breaks Rebuy's own rendering).
  // We only add classes to Rebuy's line items and inject a header inside the
  // first item of each group. Self-healing: clears prior decoration first.
  function decorate() {
    const list = document.querySelector("ul[data-smartcart-items]");
    if (!list) return;

    // 1. Clear previous decoration (headers + classes) so this is idempotent.
    list.querySelectorAll(".rb-bundle-head").forEach((h) => h.remove());
    list.querySelectorAll(".rb-bundle-item").forEach((el) => {
      el.classList.remove("rb-bundle-item", "rb-bundle-first", "rb-bundle-last", "rb-bundle-removing", "rb-bundle-merged");
      el.removeAttribute("data-rb-token");
    });

    // 2. Group line items by their own _bundle_id class token.
    const order = [];
    const byToken = {};
    list.querySelectorAll(".rebuy-cart__flyout-item").forEach((el) => {
      const t = rbDomToken(el);
      if (!t) return;
      if (!byToken[t]) { byToken[t] = []; order.push(t); }
      byToken[t].push(el);
    });
    if (!order.length) return;
    ensureBundleStyles();

    // 3. Decorate each group in place + inject a header into its first item.
    order.forEach((t) => {
      const allItems = byToken[t];
      rbCollapseSplitRows(t, allItems);
      const items = allItems.filter((el) => !el.classList.contains("rb-bundle-merged"));
      allItems.forEach((el) => {
        el.classList.add("rb-bundle-item");
        el.setAttribute("data-rb-token", t);
      });
      items.forEach((el, i) => {
        if (i === 0) el.classList.add("rb-bundle-first");
        if (i === items.length - 1) el.classList.add("rb-bundle-last");
      });

      const first = items[0];
      const info = rbGroupInfo(t);
      const priceText = (info.total != null && typeof formatMoney === "function" && window.theme && window.theme.moneyFormat)
        ? formatMoney(info.total, window.theme.moneyFormat)
        : "";

      const head = document.createElement("div");
      head.className = "rb-bundle-head";
      head.innerHTML =
        '<div class="rb-bundle-head__info">' +
          '<span class="rb-bundle-head__title">Bundle</span>' +
          (info.plan ? '<span class="rb-bundle-head__meta">' + info.plan + "</span>" : "") +
          '<button type="button" class="rb-bundle-head__remove">' + rbRemoveLabel() + "</button>" +
        "</div>" +
        (priceText ? '<span class="rb-bundle-head__price">' + priceText + "</span>" : "");

      first.insertBefore(head, first.firstChild);
      head.querySelector(".rb-bundle-head__remove")
        .addEventListener("click", () => removeBundleByToken(t));

      if (info.handle) {
        fetchBundleProduct(info.handle).then((p) => {
          if (!p || !head.parentNode) return;
          const titleEl = head.querySelector(".rb-bundle-head__title");
          if (titleEl) titleEl.textContent = p.title;
          const imgSrc = p.featured_image || (p.images && p.images[0]);
          if (imgSrc && !head.querySelector(".rb-bundle-head__image")) {
            const imgEl = document.createElement("img");
            imgEl.className = "rb-bundle-head__image";
            imgEl.src = imgSrc;
            imgEl.alt = p.title || "";
            imgEl.width = 40;
            imgEl.height = 40;
            head.insertBefore(imgEl, head.firstChild);
          }
        });
      }
    });
  }

  // Re-run on Rebuy renders AND on actual DOM changes to the cart list — Rebuy
  // paints AJAX updates after its change event fires, so the observer is what
  // catches a newly-added second bundle. The observer disconnects during our
  // own mutations to avoid a feedback loop; decorate() is idempotent.
  let rbObserver = null;
  let rbList = null;
  let rbScheduled = false;

  function rbScheduleDecorate() {
    if (rbScheduled) return;
    rbScheduled = true;
    requestAnimationFrame(() => {
      rbScheduled = false;
      if (rbObserver) rbObserver.disconnect();
      decorate();
      rbAttachObserver();
    });
  }

  function rbAttachObserver() {
    const list = document.querySelector("ul[data-smartcart-items]");
    if (!list) return;
    if (!rbObserver) rbObserver = new MutationObserver(rbScheduleDecorate);
    rbObserver.disconnect();
    rbList = list;
    rbObserver.observe(list, { childList: true });
  }

  ["rebuy:smartcart.ready", "rebuy:smartcart.show", "rebuy:cart.change"].forEach((ev) => {
    document.addEventListener(ev, () => { rbAttachObserver(); rbScheduleDecorate(); });
  });
})();

// =============================================================================
// Quiz results — companion cards + greeting + storytelling texts
// Handles the per-user bits of the quiz results page (product.quiz-results):
//   - Fills companion meal / pâté / treat / add-on cards from
//     ?ef_meals= / ?ef_pates= / ?ef_treats= / ?ef_addons=
//   - Swaps pet name (?ef_pet) into the greeting
//   - Fetches the personalised storytelling sections by ?ef_rid= from the quiz
//     API (GET /quiz/result/:id) and renders them as HTML (server-escaped, only
//     <p>/<u> tags — variables are underlined per the design). Falls back to the
//     plain ?ef_why= line when the fetch fails or for old results.
// =============================================================================
(function () {
  "use strict";

  if (window.__efCompanionsInit) return;
  window.__efCompanionsInit = true;

  const CARD_SECTION_ID = "api-product-grid-item";
  const DEFAULT_MAX_CARDS = 2;

  ready(start);

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  function start() {
    if (window.Shopify && window.Shopify.designMode) return;

    const params = new URLSearchParams(window.location.search);

    fillGreeting((params.get("ef_pet") || "").trim());
    fillWhy((params.get("ef_why") || "").trim());

    // Companion pâtés only accompany a MEAL result — when the pâté itself is
    // the headline they would double up on it, so the section stays hidden
    // (also guards old shared links that still carry ef_pates).
    const resultFormat = (params.get("ef_format") || "meal").trim();
    const lists = {
      meals: { handles: splitHandles(params.get("ef_meals")), notes: [] },
      pates: {
        handles: resultFormat === "pate" ? [] : splitHandles(params.get("ef_pates")),
        notes: [],
      },
      treats: { handles: splitHandles(params.get("ef_treats")), notes: [] },
      addons: {
        handles: splitHandles(params.get("ef_addons")),
        notes: (params.get("ef_addon_notes") || "").split("|"),
      },
    };

    document.querySelectorAll("[data-ef-mount]").forEach((grid) => {
      const source = grid.getAttribute("data-ef-mount");
      const list = lists[source] || { handles: [], notes: [] };
      fillGrid(grid, list.handles, list.notes);
    });

    // Storytelling sections: fetched by response id so multi-paragraph copy
    // (way beyond URL limits) renders, and shared links replay the same texts.
    const rid = (params.get("ef_rid") || "").trim();
    const format = (params.get("ef_format") || "meal").trim();
    if (rid && /^[a-z0-9]{10,64}$/i.test(rid)) {
      fetchNarrative(rid)
        .then((data) => {
          if (data && data.sections) fillNarrative(data.sections, format);
        })
        .catch(() => {
          /* keep the ef_why fallback already rendered */
        });
    }
  }

  // Pet name into the greeting heading; editor fallback when absent.
  function fillGreeting(petName) {
    document.querySelectorAll("[data-ef-greeting]").forEach((el) => {
      el.textContent = petName || el.getAttribute("data-ef-greeting-fallback") || "your pet";
    });
  }

  // The plain ?ef_why fallback line (replaced by the storytelling greeting when
  // the ef_rid fetch succeeds — fillNarrative restores display then).
  function fillWhy(why) {
    document.querySelectorAll("[data-ef-why]").forEach((el) => {
      if (why) el.textContent = why;
      if (!el.textContent.trim()) el.style.display = "none";
    });
  }

  // API base: section setting first (works for SHARED links on any device),
  // then the widget's stored result (same browser as the quiz run).
  function apiBase() {
    const el = document.querySelector("[data-ef-api-url]");
    const fromAttr = el && el.getAttribute("data-ef-api-url");
    if (fromAttr && fromAttr.trim()) return fromAttr.trim().replace(/\/$/, "");
    try {
      const raw =
        window.localStorage.getItem("ef-quiz-result") ||
        window.sessionStorage.getItem("ef-quiz-result");
      const data = raw ? JSON.parse(raw) : null;
      if (data && typeof data.apiBase === "string" && data.apiBase) {
        return data.apiBase.replace(/\/$/, "");
      }
    } catch {
      /* storage unavailable */
    }
    return null;
  }

  async function fetchNarrative(rid) {
    const base = apiBase();
    if (!base) return null;
    const res = await fetch(`${base}/quiz/result/${encodeURIComponent(rid)}`, {
      headers: { Accept: "application/json" },
    });
    if (!res.ok) return null;
    return res.json();
  }

  // The section payloads are server-escaped HTML carrying only <p>/<u> tags
  // (headings: <em>; the API escapes every user-supplied value), so innerHTML
  // is safe here.
  function fillNarrative(sections, format) {
    if (sections.greeting && sections.greeting.html) {
      document.querySelectorAll("[data-ef-why]").forEach((el) => {
        el.innerHTML = sections.greeting.html;
        el.style.display = "";
      });
    }
    // Personalised top heading replaces the locale "{pet}'s perfect match" line.
    if (sections.greeting && sections.greeting.heading && sections.greeting.heading.html) {
      document.querySelectorAll('[data-ef-heading="greeting"]').forEach((el) => {
        el.innerHTML = sections.greeting.heading.html;
        el.hidden = false;
      });
    }
    // The secondary text belongs to whichever section shows the OTHER product:
    // the dry-meal instance on a pâté result, the pâté instance otherwise.
    if (sections.secondary) {
      const target = format === "pate" ? "meals" : "pates";
      fillSection(target, sections.secondary);
    }
    fillSection("treats", sections.treats);
    fillSection("addons", sections.addons);
  }

  function fillSection(source, section) {
    if (!section) return;
    if (section.html) fillIntro(source, section.html);
    if (section.heading && section.heading.html) {
      document.querySelectorAll(`[data-ef-heading="${source}"]`).forEach((el) => {
        el.innerHTML = section.heading.html;
        el.hidden = false;
      });
    }
  }

  function fillIntro(source, html) {
    document.querySelectorAll(`[data-ef-intro="${source}"]`).forEach((el) => {
      el.innerHTML = html;
      el.hidden = false;
    });
  }

  async function fillGrid(grid, handles, notes = []) {
    const section = grid.closest("[data-ef-companions]") || grid;

    // Per-section card cap (theme-editor setting; default 2).
    const maxCards =
      parseInt(section.getAttribute && section.getAttribute("data-ef-max-cards"), 10) ||
      DEFAULT_MAX_CARDS;
    handles = handles.slice(0, maxCards);

    if (!handles.length) {
      hide(section);
      return;
    }

    const fetched = await Promise.all(
      handles.map((h, i) => fetchCard(h).then((card) => (card ? { card, note: notes[i] } : null)))
    );
    const cards = fetched.filter(Boolean);

    if (!cards.length) {
      hide(section);
      return;
    }

    grid.innerHTML = "";
    cards.forEach(({ card, note }) => {
      if (note && note.trim()) {
        const p = document.createElement("p");
        p.className = "ef-companions__note";
        p.textContent = note.trim();
        card.appendChild(p);
      }
      grid.appendChild(card);
      revealAos(card);
    });

    const slider = grid.closest("grid-slider");
    if (slider) {
      slider.dispatchEvent(new CustomEvent("theme:grid-slider:init"));
      grid.classList.remove("scroll-snap-disabled");
    }
  }

  function revealAos(card) {
    const targets = [card];
    card.querySelectorAll("[data-aos], .lazy-image, figure, img").forEach((el) => targets.push(el));
    targets.forEach((el) => {
      if (!el || !el.style) return;
      el.removeAttribute("data-aos");
      el.classList.add("aos-init", "aos-animate", "is-loaded");
      el.classList.remove("is-loading");
      el.style.opacity = "1";
      el.style.transform = "none";
    });
  }

  function hide(el) {
    el.classList.add("ef-companions--empty");
  }

  function splitHandles(value) {
    return (value || "")
      .split(",")
      .map((h) => h.trim())
      .filter(Boolean);
  }

  async function fetchCard(handle) {
    try {
      const res = await fetch(
        `/products/${encodeURIComponent(handle)}?section_id=${CARD_SECTION_ID}`,
        { headers: { Accept: "text/html" } }
      );
      if (!res.ok) return null;
      const tmp = document.createElement("div");
      tmp.innerHTML = await res.text();
      const card =
        tmp.querySelector("[data-grid-item]") ||
        tmp.querySelector("[data-api-content]") ||
        (tmp.children.length ? tmp : null);
      if (!card) {
        console.warn("[quiz-companions] No card element found for handle:", handle, "— section_id:", CARD_SECTION_ID);
        return null;
      }
      const link = card.querySelector("[data-product-link]");
      const href = link && link.getAttribute("href");
      if (!href || !href.trim()) return null;
      return card;
    } catch {
      return null;
    }
  }
})();

// =============================================================================
// Quiz results — cart + order linkage
// After the quiz, the widget stores the response id + a summary in storage
// (ef-quiz-result). Here we attach that to the Shopify cart as hidden cart
// attributes (underscore-prefixed → carried onto the order's note_attributes,
// invisible in the cart UI), and post the cart token back to the API so the saved
// submission can be tied to the order later. Runs once per response id.
// =============================================================================
(function () {
  "use strict";

  if (window.__efQuizLinkInit) return;
  window.__efQuizLinkInit = true;

  const RESULT_KEY = "ef-quiz-result";
  const SESSION_KEY = "ef-quiz-session";
  const SYNCED_KEY = "ef-quiz-synced"; // sessionStorage: response id already synced

  ready(run);

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  function readResult() {
    const stores = [];
    try {
      if (window.localStorage) stores.push(window.localStorage);
    } catch {
      /* storage blocked */
    }
    try {
      if (window.sessionStorage) stores.push(window.sessionStorage);
    } catch {
      /* storage blocked */
    }
    for (const store of stores) {
      try {
        const raw = store.getItem(RESULT_KEY);
        if (raw) return JSON.parse(raw);
      } catch {
        /* ignore malformed */
      }
    }
    return null;
  }

  async function run() {
    if (window.Shopify && window.Shopify.designMode) return;

    const data = readResult();
    if (!data || !data.responseId) return;

    // Sync once per response id (avoids re-posting on every page view).
    let synced = null;
    try {
      synced = sessionStorage.getItem(SYNCED_KEY);
    } catch {
      /* ignore */
    }
    if (synced === data.responseId) return;

    const recommended = Array.isArray(data.recommended)
      ? data.recommended
          .map((r) => r && r.name)
          .filter(Boolean)
          .join(", ")
      : "";

    const attributes = {
      _ef_quiz_response_id: data.responseId,
      _ef_quiz_pet: data.petName || "",
      _ef_quiz_species: data.species || "",
      _ef_quiz_headline: (data.headline && data.headline.name) || "",
      _ef_quiz_recommended: recommended,
    };

    let cartToken = null;
    try {
      const res = await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ attributes }),
      });
      if (res.ok) {
        const cart = await res.json();
        cartToken = (cart && cart.token) || null;
      }
    } catch {
      // Cart update failed — leave unsynced so a later page load retries.
      return;
    }

    if (!cartToken) {
      try {
        const cart = await (await fetch("/cart.js")).json();
        cartToken = (cart && cart.token) || null;
      } catch {
        /* ignore */
      }
    }

    // Hand the cart token (+ session) to the API so the submission can be tied to
    // the eventual order. apiBase was stored by the quiz (e.g. "https://…/api").
    if (cartToken && data.apiBase) {
      let sessionId = null;
      try {
        sessionId = localStorage.getItem(SESSION_KEY);
      } catch {
        /* ignore */
      }
      try {
        await fetch(`${data.apiBase}/quiz/link`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ responseId: data.responseId, cartToken, sessionId }),
          keepalive: true,
        });
      } catch {
        /* non-fatal — attributes are already on the cart */
      }
    }

    try {
      sessionStorage.setItem(SYNCED_KEY, data.responseId);
    } catch {
      /* ignore */
    }
  }
})();
/* =========================================================================
   PDP — "Our secrets" ingredient carousel  <pdp-secrets-carousel>
   Markup: snippets/product-secrets-accordion.liquid. The track is a native
   horizontal scroller (flex + overflow-x + scroll-snap), so swipe, trackpad and
   keyboard work by themselves. This element adds a draggable scrollbar under the
   cards (drag the thumb, click the track; a second bar above the cards on mobile) and
   mouse drag-to-scroll on the cards.
   No carousel library. Plan: PDP_OUR_SECRETS_PLAN.md
   ========================================================================= */
(function () {
  if (!window.customElements || customElements.get("pdp-secrets-carousel")) return;

  class PdpSecretsCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector("[data-carousel]");
      // One bar below the cards, and on mobile one above too (the cards are tall enough
      // there that the bottom bar is off screen). Every bar mirrors the same scroll state.
      this.bars = [...this.querySelectorAll("[data-carousel-scrollbar]")]
        .map((bar) => ({ bar, thumb: bar.querySelector("[data-carousel-thumb]") }))
        .filter((b) => b.thumb);
      if (!this.track || !this.bars.length) return;

      this.update = this.update.bind(this);
      this.track.addEventListener("scroll", this.update, { passive: true });
      this.ro = new ResizeObserver(this.update);
      this.ro.observe(this.track);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(this.update);
      this.update();

      this.bars.forEach((b) => {
        this.bindThumbDrag(b);
        this.bindTrackClick(b);
      });
      this.bindMouseDrag();
      this.bindSnapPolicy();
    }

    // Card-edge snapping is a touch nicety; for mouse users (scrollbar, drag, wheel) the
    // scroller behaves like any native one and stops where they leave it.
    bindSnapPolicy() {
      this.track.addEventListener("pointerdown", (e) => {
        this.track.style.scrollSnapType = e.pointerType === "touch" ? "" : "none";
      }, { passive: true });
      this.track.addEventListener("wheel", () => { this.track.style.scrollSnapType = "none"; }, { passive: true });
    }

    disconnectedCallback() {
      if (this.track) this.track.removeEventListener("scroll", this.update);
      if (this.ro) this.ro.disconnect();
    }

    // Thumb width = visible share, thumb position = scrolled share. Same on every bar.
    update() {
      const { scrollWidth, clientWidth, scrollLeft } = this.track;
      const scrollable = scrollWidth > clientWidth + 1;
      const share = clientWidth / scrollWidth;
      const pos = scrollable ? scrollLeft / (scrollWidth - clientWidth) : 0;
      this.bars.forEach(({ bar, thumb }) => {
        bar.hidden = !scrollable;
        if (!scrollable) return;
        thumb.style.width = `${share * 100}%`;
        thumb.style.left = `${pos * (1 - share) * 100}%`;
      });
    }

    bindThumbDrag({ bar, thumb }) {
      let startX = 0, startLeft = 0, dragging = false;
      thumb.addEventListener("pointerdown", (e) => {
        dragging = true; startX = e.clientX; startLeft = this.track.scrollLeft;
        // mandatory scroll-snap would pull every intermediate position back to a card edge
        this.track.style.scrollSnapType = "none";
        try { thumb.setPointerCapture(e.pointerId); } catch (err) { /* synthetic events */ }
        this.classList.add("is-dragging");
        e.preventDefault();
      });
      thumb.addEventListener("pointermove", (e) => {
        if (!dragging) return;
        const ratio = this.track.scrollWidth / bar.clientWidth;
        this.track.scrollLeft = startLeft + (e.clientX - startX) * ratio;
      });
      const stop = () => {
        if (!dragging) return;
        dragging = false;
        this.classList.remove("is-dragging");
        // Snapping stays off after a scrollbar drag, so the position the user chose holds
        // (Chrome's "proximity" still snaps anything within ~1/3 of the viewport). Touch
        // swipes switch it back on (see bindSnapPolicy).
      };
      thumb.addEventListener("pointerup", stop);
      thumb.addEventListener("pointercancel", stop);
    }

    // Click on the bar (outside the thumb) → scroll so the thumb centres there.
    bindTrackClick({ bar, thumb }) {
      bar.addEventListener("click", (e) => {
        if (e.target === thumb) return;
        const rect = bar.getBoundingClientRect();
        const share = this.track.clientWidth / this.track.scrollWidth;
        const target = (e.clientX - rect.left) / rect.width - share / 2;
        const max = this.track.scrollWidth - this.track.clientWidth;
        this.track.scrollTo({ left: Math.max(0, Math.min(max, (target / (1 - share)) * max)), behavior: "smooth" });
      });
    }

    // Mouse users can also drag the cards; a real drag suppresses the CTA click.
    bindMouseDrag() {
      let down = false, moved = false, startX = 0, startLeft = 0;
      this.track.addEventListener("pointerdown", (e) => {
        if (e.pointerType !== "mouse" || e.button !== 0) return;
        down = true; moved = false; startX = e.clientX; startLeft = this.track.scrollLeft;
        this.track.style.scrollSnapType = "none";
      });
      this.track.addEventListener("pointermove", (e) => {
        if (!down) return;
        const dx = e.clientX - startX;
        if (Math.abs(dx) > 5) { moved = true; this.classList.add("is-dragging"); }
        if (moved) { this.track.scrollLeft = startLeft - dx; e.preventDefault(); }
      });
      const end = () => {
        if (!down) return;
        down = false;
        this.classList.remove("is-dragging");
        if (moved) {
          const swallow = (ev) => { ev.preventDefault(); ev.stopPropagation(); };
          this.track.addEventListener("click", swallow, { capture: true, once: true });
          setTimeout(() => this.track.removeEventListener("click", swallow, { capture: true }), 0);
        }
      };
      this.track.addEventListener("pointerup", end);
      this.track.addEventListener("pointerleave", end);
      this.track.addEventListener("pointercancel", end);
      this.track.addEventListener("dragstart", (e) => e.preventDefault());
    }
  }

  customElements.define("pdp-secrets-carousel", PdpSecretsCarousel);
})();
